! function(e, t) {
    function i(t, i) {
        var o, s, r, a = t.nodeName.toLowerCase();
        return "area" === a ? (o = t.parentNode, s = o.name, t.href && s && "map" === o.nodeName.toLowerCase() ? (r = e("img[usemap=#" + s + "]")[0], !!r && n(r)) : !1) : (/input|select|textarea|button|object/.test(a) ? !t.disabled : "a" === a ? t.href || i : i) && n(t)
    }

    function n(t) {
        return e.expr.filters.visible(t) && !e(t).parents().addBack().filter(function() {
            return "hidden" === e.css(this, "visibility")
        }).length
    }
    var o = 0,
        s = /^ui-id-\d+$/;
    e.ui = e.ui || {}, e.extend(e.ui, {
        version: "1.10.4",
        keyCode: {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            NUMPAD_ADD: 107,
            NUMPAD_DECIMAL: 110,
            NUMPAD_DIVIDE: 111,
            NUMPAD_ENTER: 108,
            NUMPAD_MULTIPLY: 106,
            NUMPAD_SUBTRACT: 109,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38
        }
    }), e.fn.extend({
        focus: function(t) {
            return function(i, n) {
                return "number" == typeof i ? this.each(function() {
                    var t = this;
                    setTimeout(function() {
                        e(t).focus(), n && n.call(t)
                    }, i)
                }) : t.apply(this, arguments)
            }
        }(e.fn.focus),
        scrollParent: function() {
            var t;
            return t = e.ui.ie && /(static|relative)/.test(this.css("position")) || /absolute/.test(this.css("position")) ? this.parents().filter(function() {
                return /(relative|absolute|fixed)/.test(e.css(this, "position")) && /(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"))
            }).eq(0) : this.parents().filter(function() {
                return /(auto|scroll)/.test(e.css(this, "overflow") + e.css(this, "overflow-y") + e.css(this, "overflow-x"))
            }).eq(0), /fixed/.test(this.css("position")) || !t.length ? e(document) : t
        },
        zIndex: function(i) {
            if (i !== t) return this.css("zIndex", i);
            if (this.length)
                for (var n, o, s = e(this[0]); s.length && s[0] !== document;) {
                    if (n = s.css("position"), ("absolute" === n || "relative" === n || "fixed" === n) && (o = parseInt(s.css("zIndex"), 10), !isNaN(o) && 0 !== o)) return o;
                    s = s.parent()
                }
            return 0
        },
        uniqueId: function() {
            return this.each(function() {
                this.id || (this.id = "ui-id-" + ++o)
            })
        },
        removeUniqueId: function() {
            return this.each(function() {
                s.test(this.id) && e(this).removeAttr("id")
            })
        }
    }), e.extend(e.expr[":"], {
        data: e.expr.createPseudo ? e.expr.createPseudo(function(t) {
            return function(i) {
                return !!e.data(i, t)
            }
        }) : function(t, i, n) {
            return !!e.data(t, n[3])
        },
        focusable: function(t) {
            return i(t, !isNaN(e.attr(t, "tabindex")))
        },
        tabbable: function(t) {
            var n = e.attr(t, "tabindex"),
                o = isNaN(n);
            return (o || n >= 0) && i(t, !o)
        }
    }), e("<a>").outerWidth(1).jquery || e.each(["Width", "Height"], function(i, n) {
        function o(t, i, n, o) {
            return e.each(s, function() {
                i -= parseFloat(e.css(t, "padding" + this)) || 0, n && (i -= parseFloat(e.css(t, "border" + this + "Width")) || 0), o && (i -= parseFloat(e.css(t, "margin" + this)) || 0)
            }), i
        }
        var s = "Width" === n ? ["Left", "Right"] : ["Top", "Bottom"],
            r = n.toLowerCase(),
            a = {
                innerWidth: e.fn.innerWidth,
                innerHeight: e.fn.innerHeight,
                outerWidth: e.fn.outerWidth,
                outerHeight: e.fn.outerHeight
            };
        e.fn["inner" + n] = function(i) {
            return i === t ? a["inner" + n].call(this) : this.each(function() {
                e(this).css(r, o(this, i) + "px")
            })
        }, e.fn["outer" + n] = function(t, i) {
            return "number" != typeof t ? a["outer" + n].call(this, t) : this.each(function() {
                e(this).css(r, o(this, t, !0, i) + "px")
            })
        }
    }), e.fn.addBack || (e.fn.addBack = function(e) {
        return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
    }), e("<a>").data("a-b", "a").removeData("a-b").data("a-b") && (e.fn.removeData = function(t) {
        return function(i) {
            return arguments.length ? t.call(this, e.camelCase(i)) : t.call(this)
        }
    }(e.fn.removeData)), e.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()), e.support.selectstart = "onselectstart" in document.createElement("div"), e.fn.extend({
        disableSelection: function() {
            return this.bind((e.support.selectstart ? "selectstart" : "mousedown") + ".ui-disableSelection", function(e) {
                e.preventDefault()
            })
        },
        enableSelection: function() {
            return this.unbind(".ui-disableSelection")
        }
    }), e.extend(e.ui, {
        plugin: {
            add: function(t, i, n) {
                var o, s = e.ui[t].prototype;
                for (o in n) s.plugins[o] = s.plugins[o] || [], s.plugins[o].push([i, n[o]])
            },
            call: function(e, t, i) {
                var n, o = e.plugins[t];
                if (o && e.element[0].parentNode && 11 !== e.element[0].parentNode.nodeType)
                    for (n = 0; o.length > n; n++) e.options[o[n][0]] && o[n][1].apply(e.element, i)
            }
        },
        hasScroll: function(t, i) {
            if ("hidden" === e(t).css("overflow")) return !1;
            var n = i && "left" === i ? "scrollLeft" : "scrollTop",
                o = !1;
            return t[n] > 0 ? !0 : (t[n] = 1, o = t[n] > 0, t[n] = 0, o)
        }
    })
}(jQuery),
function(e, t) {
    var i = 0,
        n = Array.prototype.slice,
        o = e.cleanData;
    e.cleanData = function(t) {
        for (var i, n = 0; null != (i = t[n]); n++) try {
            e(i).triggerHandler("remove")
        } catch (s) {}
        o(t)
    }, e.widget = function(i, n, o) {
        var s, r, a, u, l = {},
            c = i.split(".")[0];
        i = i.split(".")[1], s = c + "-" + i, o || (o = n, n = e.Widget), e.expr[":"][s.toLowerCase()] = function(t) {
            return !!e.data(t, s)
        }, e[c] = e[c] || {}, r = e[c][i], a = e[c][i] = function(e, i) {
            return this._createWidget ? (arguments.length && this._createWidget(e, i), t) : new a(e, i)
        }, e.extend(a, r, {
            version: o.version,
            _proto: e.extend({}, o),
            _childConstructors: []
        }), u = new n, u.options = e.widget.extend({}, u.options), e.each(o, function(i, o) {
            return e.isFunction(o) ? (l[i] = function() {
                var e = function() {
                        return n.prototype[i].apply(this, arguments)
                    },
                    t = function(e) {
                        return n.prototype[i].apply(this, e)
                    };
                return function() {
                    var i, n = this._super,
                        s = this._superApply;
                    return this._super = e, this._superApply = t, i = o.apply(this, arguments), this._super = n, this._superApply = s, i
                }
            }(), t) : (l[i] = o, t)
        }), a.prototype = e.widget.extend(u, {
            widgetEventPrefix: r ? u.widgetEventPrefix || i : i
        }, l, {
            constructor: a,
            namespace: c,
            widgetName: i,
            widgetFullName: s
        }), r ? (e.each(r._childConstructors, function(t, i) {
            var n = i.prototype;
            e.widget(n.namespace + "." + n.widgetName, a, i._proto)
        }), delete r._childConstructors) : n._childConstructors.push(a), e.widget.bridge(i, a)
    }, e.widget.extend = function(i) {
        for (var o, s, r = n.call(arguments, 1), a = 0, u = r.length; u > a; a++)
            for (o in r[a]) s = r[a][o], r[a].hasOwnProperty(o) && s !== t && (i[o] = e.isPlainObject(s) ? e.isPlainObject(i[o]) ? e.widget.extend({}, i[o], s) : e.widget.extend({}, s) : s);
        return i
    }, e.widget.bridge = function(i, o) {
        var s = o.prototype.widgetFullName || i;
        e.fn[i] = function(r) {
            var a = "string" == typeof r,
                u = n.call(arguments, 1),
                l = this;
            return r = !a && u.length ? e.widget.extend.apply(null, [r].concat(u)) : r, this.each(a ? function() {
                var n, o = e.data(this, s);
                return o ? e.isFunction(o[r]) && "_" !== r.charAt(0) ? (n = o[r].apply(o, u), n !== o && n !== t ? (l = n && n.jquery ? l.pushStack(n.get()) : n, !1) : t) : e.error("no such method '" + r + "' for " + i + " widget instance") : e.error("cannot call methods on " + i + " prior to initialization; attempted to call method '" + r + "'")
            } : function() {
                var t = e.data(this, s);
                t ? t.option(r || {})._init() : e.data(this, s, new o(r, this))
            }), l
        }
    }, e.Widget = function() {}, e.Widget._childConstructors = [], e.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {
            disabled: !1,
            create: null
        },
        _createWidget: function(t, n) {
            n = e(n || this.defaultElement || this)[0], this.element = e(n), this.uuid = i++, this.eventNamespace = "." + this.widgetName + this.uuid, this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this.bindings = e(), this.hoverable = e(), this.focusable = e(), n !== this && (e.data(n, this.widgetFullName, this), this._on(!0, this.element, {
                remove: function(e) {
                    e.target === n && this.destroy()
                }
            }), this.document = e(n.style ? n.ownerDocument : n.document || n), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this._create(), this._trigger("create", null, this._getCreateEventData()), this._init()
        },
        _getCreateOptions: e.noop,
        _getCreateEventData: e.noop,
        _create: e.noop,
        _init: e.noop,
        destroy: function() {
            this._destroy(), this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)), this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName + "-disabled ui-state-disabled"), this.bindings.unbind(this.eventNamespace), this.hoverable.removeClass("ui-state-hover"), this.focusable.removeClass("ui-state-focus")
        },
        _destroy: e.noop,
        widget: function() {
            return this.element
        },
        option: function(i, n) {
            var o, s, r, a = i;
            if (0 === arguments.length) return e.widget.extend({}, this.options);
            if ("string" == typeof i)
                if (a = {}, o = i.split("."), i = o.shift(), o.length) {
                    for (s = a[i] = e.widget.extend({}, this.options[i]), r = 0; o.length - 1 > r; r++) s[o[r]] = s[o[r]] || {}, s = s[o[r]];
                    if (i = o.pop(), 1 === arguments.length) return s[i] === t ? null : s[i];
                    s[i] = n
                } else {
                    if (1 === arguments.length) return this.options[i] === t ? null : this.options[i];
                    a[i] = n
                }
            return this._setOptions(a), this
        },
        _setOptions: function(e) {
            var t;
            for (t in e) this._setOption(t, e[t]);
            return this
        },
        _setOption: function(e, t) {
            return this.options[e] = t, "disabled" === e && (this.widget().toggleClass(this.widgetFullName + "-disabled ui-state-disabled", !!t).attr("aria-disabled", t), this.hoverable.removeClass("ui-state-hover"), this.focusable.removeClass("ui-state-focus")), this
        },
        enable: function() {
            return this._setOption("disabled", !1)
        },
        disable: function() {
            return this._setOption("disabled", !0)
        },
        _on: function(i, n, o) {
            var s, r = this;
            "boolean" != typeof i && (o = n, n = i, i = !1), o ? (n = s = e(n), this.bindings = this.bindings.add(n)) : (o = n, n = this.element, s = this.widget()), e.each(o, function(o, a) {
                function u() {
                    return i || r.options.disabled !== !0 && !e(this).hasClass("ui-state-disabled") ? ("string" == typeof a ? r[a] : a).apply(r, arguments) : t
                }
                "string" != typeof a && (u.guid = a.guid = a.guid || u.guid || e.guid++);
                var l = o.match(/^(\w+)\s*(.*)$/),
                    c = l[1] + r.eventNamespace,
                    h = l[2];
                h ? s.delegate(h, c, u) : n.bind(c, u)
            })
        },
        _off: function(e, t) {
            t = (t || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, e.unbind(t).undelegate(t)
        },
        _delay: function(e, t) {
            function i() {
                return ("string" == typeof e ? n[e] : e).apply(n, arguments)
            }
            var n = this;
            return setTimeout(i, t || 0)
        },
        _hoverable: function(t) {
            this.hoverable = this.hoverable.add(t), this._on(t, {
                mouseenter: function(t) {
                    e(t.currentTarget).addClass("ui-state-hover")
                },
                mouseleave: function(t) {
                    e(t.currentTarget).removeClass("ui-state-hover")
                }
            })
        },
        _focusable: function(t) {
            this.focusable = this.focusable.add(t), this._on(t, {
                focusin: function(t) {
                    e(t.currentTarget).addClass("ui-state-focus")
                },
                focusout: function(t) {
                    e(t.currentTarget).removeClass("ui-state-focus")
                }
            })
        },
        _trigger: function(t, i, n) {
            var o, s, r = this.options[t];
            if (n = n || {}, i = e.Event(i), i.type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), i.target = this.element[0], s = i.originalEvent)
                for (o in s) o in i || (i[o] = s[o]);
            return this.element.trigger(i, n), !(e.isFunction(r) && r.apply(this.element[0], [i].concat(n)) === !1 || i.isDefaultPrevented())
        }
    }, e.each({
        show: "fadeIn",
        hide: "fadeOut"
    }, function(t, i) {
        e.Widget.prototype["_" + t] = function(n, o, s) {
            "string" == typeof o && (o = {
                effect: o
            });
            var r, a = o ? o === !0 || "number" == typeof o ? i : o.effect || i : t;
            o = o || {}, "number" == typeof o && (o = {
                duration: o
            }), r = !e.isEmptyObject(o), o.complete = s, o.delay && n.delay(o.delay), r && e.effects && e.effects.effect[a] ? n[t](o) : a !== t && n[a] ? n[a](o.duration, o.easing, s) : n.queue(function(i) {
                e(this)[t](), s && s.call(n[0]), i()
            })
        }
    })
}(jQuery),
function(e) {
    var t = !1;
    e(document).mouseup(function() {
        t = !1
    }), e.widget("ui.mouse", {
        version: "1.10.4",
        options: {
            cancel: "input,textarea,button,select,option",
            distance: 1,
            delay: 0
        },
        _mouseInit: function() {
            var t = this;
            this.element.bind("mousedown." + this.widgetName, function(e) {
                return t._mouseDown(e)
            }).bind("click." + this.widgetName, function(i) {
                return !0 === e.data(i.target, t.widgetName + ".preventClickEvent") ? (e.removeData(i.target, t.widgetName + ".preventClickEvent"), i.stopImmediatePropagation(), !1) : void 0
            }), this.started = !1
        },
        _mouseDestroy: function() {
            this.element.unbind("." + this.widgetName), this._mouseMoveDelegate && e(document).unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate)
        },
        _mouseDown: function(i) {
            if (!t) {
                this._mouseStarted && this._mouseUp(i), this._mouseDownEvent = i;
                var n = this,
                    o = 1 === i.which,
                    s = "string" == typeof this.options.cancel && i.target.nodeName ? e(i.target).closest(this.options.cancel).length : !1;
                return o && !s && this._mouseCapture(i) ? (this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function() {
                    n.mouseDelayMet = !0
                }, this.options.delay)), this._mouseDistanceMet(i) && this._mouseDelayMet(i) && (this._mouseStarted = this._mouseStart(i) !== !1, !this._mouseStarted) ? (i.preventDefault(), !0) : (!0 === e.data(i.target, this.widgetName + ".preventClickEvent") && e.removeData(i.target, this.widgetName + ".preventClickEvent"), this._mouseMoveDelegate = function(e) {
                    return n._mouseMove(e)
                }, this._mouseUpDelegate = function(e) {
                    return n._mouseUp(e)
                }, e(document).bind("mousemove." + this.widgetName, this._mouseMoveDelegate).bind("mouseup." + this.widgetName, this._mouseUpDelegate), i.preventDefault(), t = !0, !0)) : !0
            }
        },
        _mouseMove: function(t) {
            return e.ui.ie && (!document.documentMode || 9 > document.documentMode) && !t.button ? this._mouseUp(t) : this._mouseStarted ? (this._mouseDrag(t), t.preventDefault()) : (this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, t) !== !1, this._mouseStarted ? this._mouseDrag(t) : this._mouseUp(t)), !this._mouseStarted)
        },
        _mouseUp: function(t) {
            return e(document).unbind("mousemove." + this.widgetName, this._mouseMoveDelegate).unbind("mouseup." + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, t.target === this._mouseDownEvent.target && e.data(t.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(t)), !1
        },
        _mouseDistanceMet: function(e) {
            return Math.max(Math.abs(this._mouseDownEvent.pageX - e.pageX), Math.abs(this._mouseDownEvent.pageY - e.pageY)) >= this.options.distance
        },
        _mouseDelayMet: function() {
            return this.mouseDelayMet
        },
        _mouseStart: function() {},
        _mouseDrag: function() {},
        _mouseStop: function() {},
        _mouseCapture: function() {
            return !0
        }
    })
}(jQuery),
function(e, t) {
    function i(e, t, i) {
        return [parseFloat(e[0]) * (f.test(e[0]) ? t / 100 : 1), parseFloat(e[1]) * (f.test(e[1]) ? i / 100 : 1)]
    }

    function n(t, i) {
        return parseInt(e.css(t, i), 10) || 0
    }

    function o(t) {
        var i = t[0];
        return 9 === i.nodeType ? {
            width: t.width(),
            height: t.height(),
            offset: {
                top: 0,
                left: 0
            }
        } : e.isWindow(i) ? {
            width: t.width(),
            height: t.height(),
            offset: {
                top: t.scrollTop(),
                left: t.scrollLeft()
            }
        } : i.preventDefault ? {
            width: 0,
            height: 0,
            offset: {
                top: i.pageY,
                left: i.pageX
            }
        } : {
            width: t.outerWidth(),
            height: t.outerHeight(),
            offset: t.offset()
        }
    }
    e.ui = e.ui || {};
    var s, r = Math.max,
        a = Math.abs,
        u = Math.round,
        l = /left|center|right/,
        c = /top|center|bottom/,
        h = /[\+\-]\d+(\.[\d]+)?%?/,
        d = /^\w+/,
        f = /%$/,
        p = e.fn.position;
    e.position = {
            scrollbarWidth: function() {
                if (s !== t) return s;
                var i, n, o = e("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),
                    r = o.children()[0];
                return e("body").append(o), i = r.offsetWidth, o.css("overflow", "scroll"), n = r.offsetWidth, i === n && (n = o[0].clientWidth), o.remove(), s = i - n
            },
            getScrollInfo: function(t) {
                var i = t.isWindow || t.isDocument ? "" : t.element.css("overflow-x"),
                    n = t.isWindow || t.isDocument ? "" : t.element.css("overflow-y"),
                    o = "scroll" === i || "auto" === i && t.width < t.element[0].scrollWidth,
                    s = "scroll" === n || "auto" === n && t.height < t.element[0].scrollHeight;
                return {
                    width: s ? e.position.scrollbarWidth() : 0,
                    height: o ? e.position.scrollbarWidth() : 0
                }
            },
            getWithinInfo: function(t) {
                var i = e(t || window),
                    n = e.isWindow(i[0]),
                    o = !!i[0] && 9 === i[0].nodeType;
                return {
                    element: i,
                    isWindow: n,
                    isDocument: o,
                    offset: i.offset() || {
                        left: 0,
                        top: 0
                    },
                    scrollLeft: i.scrollLeft(),
                    scrollTop: i.scrollTop(),
                    width: n ? i.width() : i.outerWidth(),
                    height: n ? i.height() : i.outerHeight()
                }
            }
        }, e.fn.position = function(t) {
            if (!t || !t.of) return p.apply(this, arguments);
            t = e.extend({}, t);
            var s, f, m, v, g, b, y = e(t.of),
                _ = e.position.getWithinInfo(t.within),
                x = e.position.getScrollInfo(_),
                w = (t.collision || "flip").split(" "),
                T = {};
            return b = o(y), y[0].preventDefault && (t.at = "left top"), f = b.width, m = b.height, v = b.offset, g = e.extend({}, v), e.each(["my", "at"], function() {
                var e, i, n = (t[this] || "").split(" ");
                1 === n.length && (n = l.test(n[0]) ? n.concat(["center"]) : c.test(n[0]) ? ["center"].concat(n) : ["center", "center"]), n[0] = l.test(n[0]) ? n[0] : "center", n[1] = c.test(n[1]) ? n[1] : "center", e = h.exec(n[0]), i = h.exec(n[1]), T[this] = [e ? e[0] : 0, i ? i[0] : 0], t[this] = [d.exec(n[0])[0], d.exec(n[1])[0]]
            }), 1 === w.length && (w[1] = w[0]), "right" === t.at[0] ? g.left += f : "center" === t.at[0] && (g.left += f / 2), "bottom" === t.at[1] ? g.top += m : "center" === t.at[1] && (g.top += m / 2), s = i(T.at, f, m), g.left += s[0], g.top += s[1], this.each(function() {
                var o, l, c = e(this),
                    h = c.outerWidth(),
                    d = c.outerHeight(),
                    p = n(this, "marginLeft"),
                    b = n(this, "marginTop"),
                    E = h + p + n(this, "marginRight") + x.width,
                    C = d + b + n(this, "marginBottom") + x.height,
                    D = e.extend({}, g),
                    S = i(T.my, c.outerWidth(), c.outerHeight());
                "right" === t.my[0] ? D.left -= h : "center" === t.my[0] && (D.left -= h / 2), "bottom" === t.my[1] ? D.top -= d : "center" === t.my[1] && (D.top -= d / 2), D.left += S[0], D.top += S[1], e.support.offsetFractions || (D.left = u(D.left), D.top = u(D.top)), o = {
                    marginLeft: p,
                    marginTop: b
                }, e.each(["left", "top"], function(i, n) {
                    e.ui.position[w[i]] && e.ui.position[w[i]][n](D, {
                        targetWidth: f,
                        targetHeight: m,
                        elemWidth: h,
                        elemHeight: d,
                        collisionPosition: o,
                        collisionWidth: E,
                        collisionHeight: C,
                        offset: [s[0] + S[0], s[1] + S[1]],
                        my: t.my,
                        at: t.at,
                        within: _,
                        elem: c
                    })
                }), t.using && (l = function(e) {
                    var i = v.left - D.left,
                        n = i + f - h,
                        o = v.top - D.top,
                        s = o + m - d,
                        u = {
                            target: {
                                element: y,
                                left: v.left,
                                top: v.top,
                                width: f,
                                height: m
                            },
                            element: {
                                element: c,
                                left: D.left,
                                top: D.top,
                                width: h,
                                height: d
                            },
                            horizontal: 0 > n ? "left" : i > 0 ? "right" : "center",
                            vertical: 0 > s ? "top" : o > 0 ? "bottom" : "middle"
                        };
                    h > f && f > a(i + n) && (u.horizontal = "center"), d > m && m > a(o + s) && (u.vertical = "middle"), u.important = r(a(i), a(n)) > r(a(o), a(s)) ? "horizontal" : "vertical", t.using.call(this, e, u)
                }), c.offset(e.extend(D, {
                    using: l
                }))
            })
        }, e.ui.position = {
            fit: {
                left: function(e, t) {
                    var i, n = t.within,
                        o = n.isWindow ? n.scrollLeft : n.offset.left,
                        s = n.width,
                        a = e.left - t.collisionPosition.marginLeft,
                        u = o - a,
                        l = a + t.collisionWidth - s - o;
                    t.collisionWidth > s ? u > 0 && 0 >= l ? (i = e.left + u + t.collisionWidth - s - o, e.left += u - i) : e.left = l > 0 && 0 >= u ? o : u > l ? o + s - t.collisionWidth : o : u > 0 ? e.left += u : l > 0 ? e.left -= l : e.left = r(e.left - a, e.left)
                },
                top: function(e, t) {
                    var i, n = t.within,
                        o = n.isWindow ? n.scrollTop : n.offset.top,
                        s = t.within.height,
                        a = e.top - t.collisionPosition.marginTop,
                        u = o - a,
                        l = a + t.collisionHeight - s - o;
                    t.collisionHeight > s ? u > 0 && 0 >= l ? (i = e.top + u + t.collisionHeight - s - o, e.top += u - i) : e.top = l > 0 && 0 >= u ? o : u > l ? o + s - t.collisionHeight : o : u > 0 ? e.top += u : l > 0 ? e.top -= l : e.top = r(e.top - a, e.top)
                }
            },
            flip: {
                left: function(e, t) {
                    var i, n, o = t.within,
                        s = o.offset.left + o.scrollLeft,
                        r = o.width,
                        u = o.isWindow ? o.scrollLeft : o.offset.left,
                        l = e.left - t.collisionPosition.marginLeft,
                        c = l - u,
                        h = l + t.collisionWidth - r - u,
                        d = "left" === t.my[0] ? -t.elemWidth : "right" === t.my[0] ? t.elemWidth : 0,
                        f = "left" === t.at[0] ? t.targetWidth : "right" === t.at[0] ? -t.targetWidth : 0,
                        p = -2 * t.offset[0];
                    0 > c ? (i = e.left + d + f + p + t.collisionWidth - r - s, (0 > i || a(c) > i) && (e.left += d + f + p)) : h > 0 && (n = e.left - t.collisionPosition.marginLeft + d + f + p - u, (n > 0 || h > a(n)) && (e.left += d + f + p))
                },
                top: function(e, t) {
                    var i, n, o = t.within,
                        s = o.offset.top + o.scrollTop,
                        r = o.height,
                        u = o.isWindow ? o.scrollTop : o.offset.top,
                        l = e.top - t.collisionPosition.marginTop,
                        c = l - u,
                        h = l + t.collisionHeight - r - u,
                        d = "top" === t.my[1],
                        f = d ? -t.elemHeight : "bottom" === t.my[1] ? t.elemHeight : 0,
                        p = "top" === t.at[1] ? t.targetHeight : "bottom" === t.at[1] ? -t.targetHeight : 0,
                        m = -2 * t.offset[1];
                    0 > c ? (n = e.top + f + p + m + t.collisionHeight - r - s, e.top + f + p + m > c && (0 > n || a(c) > n) && (e.top += f + p + m)) : h > 0 && (i = e.top - t.collisionPosition.marginTop + f + p + m - u, e.top + f + p + m > h && (i > 0 || h > a(i)) && (e.top += f + p + m))
                }
            },
            flipfit: {
                left: function() {
                    e.ui.position.flip.left.apply(this, arguments), e.ui.position.fit.left.apply(this, arguments)
                },
                top: function() {
                    e.ui.position.flip.top.apply(this, arguments), e.ui.position.fit.top.apply(this, arguments)
                }
            }
        },
        function() {
            var t, i, n, o, s, r = document.getElementsByTagName("body")[0],
                a = document.createElement("div");
            t = document.createElement(r ? "div" : "body"), n = {
                visibility: "hidden",
                width: 0,
                height: 0,
                border: 0,
                margin: 0,
                background: "none"
            }, r && e.extend(n, {
                position: "absolute",
                left: "-1000px",
                top: "-1000px"
            });
            for (s in n) t.style[s] = n[s];
            t.appendChild(a), i = r || document.documentElement, i.insertBefore(t, i.firstChild), a.style.cssText = "position: absolute; left: 10.7432222px;", o = e(a).offset().left, e.support.offsetFractions = o > 10 && 11 > o, t.innerHTML = "", i.removeChild(t)
        }()
}(jQuery),
function(e) {
    e.widget("ui.autocomplete", {
        version: "1.10.4",
        defaultElement: "<input>",
        options: {
            appendTo: null,
            autoFocus: !1,
            delay: 300,
            minLength: 1,
            position: {
                my: "left top",
                at: "left bottom",
                collision: "none"
            },
            source: null,
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null
        },
        requestIndex: 0,
        pending: 0,
        _create: function() {
            var t, i, n, o = this.element[0].nodeName.toLowerCase(),
                s = "textarea" === o,
                r = "input" === o;
            this.isMultiLine = s ? !0 : r ? !1 : this.element.prop("isContentEditable"), this.valueMethod = this.element[s || r ? "val" : "text"], this.isNewMenu = !0, this.element.addClass("ui-autocomplete-input").attr("autocomplete", "off"), this._on(this.element, {
                keydown: function(o) {
                    if (this.element.prop("readOnly")) return t = !0, n = !0, void(i = !0);
                    t = !1, n = !1, i = !1;
                    var s = e.ui.keyCode;
                    switch (o.keyCode) {
                        case s.PAGE_UP:
                            t = !0, this._move("previousPage", o);
                            break;
                        case s.PAGE_DOWN:
                            t = !0, this._move("nextPage", o);
                            break;
                        case s.UP:
                            t = !0, this._keyEvent("previous", o);
                            break;
                        case s.DOWN:
                            t = !0, this._keyEvent("next", o);
                            break;
                        case s.ENTER:
                        case s.NUMPAD_ENTER:
                            this.menu.active && (t = !0, o.preventDefault(), this.menu.select(o));
                            break;
                        case s.TAB:
                            this.menu.active && this.menu.select(o);
                            break;
                        case s.ESCAPE:
                            this.menu.element.is(":visible") && (this._value(this.term), this.close(o), o.preventDefault());
                            break;
                        default:
                            i = !0, this._searchTimeout(o)
                    }
                },
                keypress: function(n) {
                    if (t) return t = !1, void((!this.isMultiLine || this.menu.element.is(":visible")) && n.preventDefault());
                    if (!i) {
                        var o = e.ui.keyCode;
                        switch (n.keyCode) {
                            case o.PAGE_UP:
                                this._move("previousPage", n);
                                break;
                            case o.PAGE_DOWN:
                                this._move("nextPage", n);
                                break;
                            case o.UP:
                                this._keyEvent("previous", n);
                                break;
                            case o.DOWN:
                                this._keyEvent("next", n)
                        }
                    }
                },
                input: function(e) {
                    return n ? (n = !1, void e.preventDefault()) : void this._searchTimeout(e)
                },
                focus: function() {
                    this.selectedItem = null, this.previous = this._value()
                },
                blur: function(e) {
                    return this.cancelBlur ? void delete this.cancelBlur : (clearTimeout(this.searching), this.close(e), void this._change(e))
                }
            }), this._initSource(), this.menu = e("<ul>").addClass("ui-autocomplete ui-front").appendTo(this._appendTo()).menu({
                role: null
            }).hide().data("ui-menu"), this._on(this.menu.element, {
                mousedown: function(t) {
                    t.preventDefault(), this.cancelBlur = !0, this._delay(function() {
                        delete this.cancelBlur
                    });
                    var i = this.menu.element[0];
                    e(t.target).closest(".ui-menu-item").length || this._delay(function() {
                        var t = this;
                        this.document.one("mousedown", function(n) {
                            n.target === t.element[0] || n.target === i || e.contains(i, n.target) || t.close()
                        })
                    })
                },
                menufocus: function(t, i) {
                    if (this.isNewMenu && (this.isNewMenu = !1, t.originalEvent && /^mouse/.test(t.originalEvent.type))) return this.menu.blur(), void this.document.one("mousemove", function() {
                        e(t.target).trigger(t.originalEvent)
                    });
                    var n = i.item.data("ui-autocomplete-item");
                    !1 !== this._trigger("focus", t, {
                        item: n
                    }) ? t.originalEvent && /^key/.test(t.originalEvent.type) && this._value(n.value) : this.liveRegion.text(n.value)
                },
                menuselect: function(e, t) {
                    var i = t.item.data("ui-autocomplete-item"),
                        n = this.previous;
                    this.element[0] !== this.document[0].activeElement && (this.element.focus(), this.previous = n, this._delay(function() {
                        this.previous = n, this.selectedItem = i
                    })), !1 !== this._trigger("select", e, {
                        item: i
                    }) && this._value(i.value), this.term = this._value(), this.close(e), this.selectedItem = i
                }
            }), this.liveRegion = e("<span>", {
                role: "status",
                "aria-live": "polite"
            }).addClass("ui-helper-hidden-accessible").insertBefore(this.element), this._on(this.window, {
                beforeunload: function() {
                    this.element.removeAttr("autocomplete")
                }
            })
        },
        _destroy: function() {
            clearTimeout(this.searching), this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"), this.menu.element.remove(), this.liveRegion.remove()
        },
        _setOption: function(e, t) {
            this._super(e, t), "source" === e && this._initSource(), "appendTo" === e && this.menu.element.appendTo(this._appendTo()), "disabled" === e && t && this.xhr && this.xhr.abort()
        },
        _appendTo: function() {
            var t = this.options.appendTo;
            return t && (t = t.jquery || t.nodeType ? e(t) : this.document.find(t).eq(0)), t || (t = this.element.closest(".ui-front")), t.length || (t = this.document[0].body), t
        },
        _initSource: function() {
            var t, i, n = this;
            e.isArray(this.options.source) ? (t = this.options.source, this.source = function(i, n) {
                n(e.ui.autocomplete.filter(t, i.term))
            }) : "string" == typeof this.options.source ? (i = this.options.source, this.source = function(t, o) {
                n.xhr && n.xhr.abort(), n.xhr = e.ajax({
                    url: i,
                    data: t,
                    dataType: "json",
                    success: function(e) {
                        o(e)
                    },
                    error: function() {
                        o([])
                    }
                })
            }) : this.source = this.options.source
        },
        _searchTimeout: function(e) {
            clearTimeout(this.searching), this.searching = this._delay(function() {
                this.term !== this._value() && (this.selectedItem = null, this.search(null, e))
            }, this.options.delay)
        },
        search: function(e, t) {
            return e = null != e ? e : this._value(), this.term = this._value(), e.length < this.options.minLength ? this.close(t) : this._trigger("search", t) !== !1 ? this._search(e) : void 0
        },
        _search: function(e) {
            this.pending++, this.element.addClass("ui-autocomplete-loading"), this.cancelSearch = !1, this.source({
                term: e
            }, this._response())
        },
        _response: function() {
            var t = ++this.requestIndex;
            return e.proxy(function(e) {
                t === this.requestIndex && this.__response(e), this.pending--, this.pending || this.element.removeClass("ui-autocomplete-loading")
            }, this)
        },
        __response: function(e) {
            e && (e = this._normalize(e)), this._trigger("response", null, {
                content: e
            }), !this.options.disabled && e && e.length && !this.cancelSearch ? (this._suggest(e), this._trigger("open")) : this._close()
        },
        close: function(e) {
            this.cancelSearch = !0, this._close(e)
        },
        _close: function(e) {
            this.menu.element.is(":visible") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger("close", e))
        },
        _change: function(e) {
            this.previous !== this._value() && this._trigger("change", e, {
                item: this.selectedItem
            })
        },
        _normalize: function(t) {
            return t.length && t[0].label && t[0].value ? t : e.map(t, function(t) {
                return "string" == typeof t ? {
                    label: t,
                    value: t
                } : e.extend({
                    label: t.label || t.value,
                    value: t.value || t.label
                }, t)
            })
        },
        _suggest: function(t) {
            var i = this.menu.element.empty();
            this._renderMenu(i, t), this.isNewMenu = !0, this.menu.refresh(), i.show(), this._resizeMenu(), i.position(e.extend({
                of: this.element
            }, this.options.position)), this.options.autoFocus && this.menu.next()
        },
        _resizeMenu: function() {
            var e = this.menu.element;
            e.outerWidth(Math.max(e.width("").outerWidth() + 1, this.element.outerWidth()))
        },
        _renderMenu: function(t, i) {
            var n = this;
            e.each(i, function(e, i) {
                n._renderItemData(t, i)
            })
        },
        _renderItemData: function(e, t) {
            return this._renderItem(e, t).data("ui-autocomplete-item", t)
        },
        _renderItem: function(t, i) {
            return e("<li>").append(e("<a>").text(i.label)).appendTo(t)
        },
        _move: function(e, t) {
            return this.menu.element.is(":visible") ? this.menu.isFirstItem() && /^previous/.test(e) || this.menu.isLastItem() && /^next/.test(e) ? (this._value(this.term), void this.menu.blur()) : void this.menu[e](t) : void this.search(null, t)
        },
        widget: function() {
            return this.menu.element
        },
        _value: function() {
            return this.valueMethod.apply(this.element, arguments)
        },
        _keyEvent: function(e, t) {
            (!this.isMultiLine || this.menu.element.is(":visible")) && (this._move(e, t), t.preventDefault())
        }
    }), e.extend(e.ui.autocomplete, {
        escapeRegex: function(e) {
            return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
        },
        filter: function(t, i) {
            var n = RegExp(e.ui.autocomplete.escapeRegex(i), "i");
            return e.grep(t, function(e) {
                return n.test(e.label || e.value || e)
            })
        }
    }), e.widget("ui.autocomplete", e.ui.autocomplete, {
        options: {
            messages: {
                noResults: "No search results.",
                results: function(e) {
                    return e + (e > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate."
                }
            }
        },
        __response: function(e) {
            var t;
            this._superApply(arguments), this.options.disabled || this.cancelSearch || (t = e && e.length ? this.options.messages.results(e.length) : this.options.messages.noResults, this.liveRegion.text(t))
        }
    })
}(jQuery),
function(e) {
    e.widget("ui.menu", {
        version: "1.10.4",
        defaultElement: "<ul>",
        delay: 300,
        options: {
            icons: {
                submenu: "ui-icon-carat-1-e"
            },
            menus: "ul",
            position: {
                my: "left top",
                at: "right top"
            },
            role: "menu",
            blur: null,
            focus: null,
            select: null
        },
        _create: function() {
            this.activeMenu = this.element, this.mouseHandled = !1, this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons", !!this.element.find(".ui-icon").length).attr({
                role: this.options.role,
                tabIndex: 0
            }).bind("click" + this.eventNamespace, e.proxy(function(e) {
                this.options.disabled && e.preventDefault()
            }, this)), this.options.disabled && this.element.addClass("ui-state-disabled").attr("aria-disabled", "true"), this._on({
                "mousedown .ui-menu-item > a": function(e) {
                    e.preventDefault()
                },
                "click .ui-state-disabled > a": function(e) {
                    e.preventDefault()
                },
                "click .ui-menu-item:has(a)": function(t) {
                    var i = e(t.target).closest(".ui-menu-item");
                    !this.mouseHandled && i.not(".ui-state-disabled").length && (this.select(t), t.isPropagationStopped() || (this.mouseHandled = !0), i.has(".ui-menu").length ? this.expand(t) : !this.element.is(":focus") && e(this.document[0].activeElement).closest(".ui-menu").length && (this.element.trigger("focus", [!0]), this.active && 1 === this.active.parents(".ui-menu").length && clearTimeout(this.timer)))
                },
                "mouseenter .ui-menu-item": function(t) {
                    var i = e(t.currentTarget);
                    i.siblings().children(".ui-state-active").removeClass("ui-state-active"), this.focus(t, i)
                },
                mouseleave: "collapseAll",
                "mouseleave .ui-menu": "collapseAll",
                focus: function(e, t) {
                    var i = this.active || this.element.children(".ui-menu-item").eq(0);
                    t || this.focus(e, i)
                },
                blur: function(t) {
                    this._delay(function() {
                        e.contains(this.element[0], this.document[0].activeElement) || this.collapseAll(t)
                    })
                },
                keydown: "_keydown"
            }), this.refresh(), this._on(this.document, {
                click: function(t) {
                    e(t.target).closest(".ui-menu").length || this.collapseAll(t), this.mouseHandled = !1
                }
            })
        },
        _destroy: function() {
            this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(), this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function() {
                var t = e(this);
                t.data("ui-menu-submenu-carat") && t.remove()
            }), this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content")
        },
        _keydown: function(t) {
            function i(e) {
                return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
            }
            var n, o, s, r, a, u = !0;
            switch (t.keyCode) {
                case e.ui.keyCode.PAGE_UP:
                    this.previousPage(t);
                    break;
                case e.ui.keyCode.PAGE_DOWN:
                    this.nextPage(t);
                    break;
                case e.ui.keyCode.HOME:
                    this._move("first", "first", t);
                    break;
                case e.ui.keyCode.END:
                    this._move("last", "last", t);
                    break;
                case e.ui.keyCode.UP:
                    this.previous(t);
                    break;
                case e.ui.keyCode.DOWN:
                    this.next(t);
                    break;
                case e.ui.keyCode.LEFT:
                    this.collapse(t);
                    break;
                case e.ui.keyCode.RIGHT:
                    this.active && !this.active.is(".ui-state-disabled") && this.expand(t);
                    break;
                case e.ui.keyCode.ENTER:
                case e.ui.keyCode.SPACE:
                    this._activate(t);
                    break;
                case e.ui.keyCode.ESCAPE:
                    this.collapse(t);
                    break;
                default:
                    u = !1, o = this.previousFilter || "", s = String.fromCharCode(t.keyCode), r = !1, clearTimeout(this.filterTimer), s === o ? r = !0 : s = o + s, a = RegExp("^" + i(s), "i"), n = this.activeMenu.children(".ui-menu-item").filter(function() {
                        return a.test(e(this).children("a").text())
                    }), n = r && -1 !== n.index(this.active.next()) ? this.active.nextAll(".ui-menu-item") : n, n.length || (s = String.fromCharCode(t.keyCode), a = RegExp("^" + i(s), "i"), n = this.activeMenu.children(".ui-menu-item").filter(function() {
                        return a.test(e(this).children("a").text())
                    })), n.length ? (this.focus(t, n), n.length > 1 ? (this.previousFilter = s, this.filterTimer = this._delay(function() {
                        delete this.previousFilter
                    }, 1e3)) : delete this.previousFilter) : delete this.previousFilter
            }
            u && t.preventDefault()
        },
        _activate: function(e) {
            this.active.is(".ui-state-disabled") || (this.active.children("a[aria-haspopup='true']").length ? this.expand(e) : this.select(e))
        },
        refresh: function() {
            var t, i = this.options.icons.submenu,
                n = this.element.find(this.options.menus);
            this.element.toggleClass("ui-menu-icons", !!this.element.find(".ui-icon").length), n.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false"
            }).each(function() {
                var t = e(this),
                    n = t.prev("a"),
                    o = e("<span>").addClass("ui-menu-icon ui-icon " + i).data("ui-menu-submenu-carat", !0);
                n.attr("aria-haspopup", "true").prepend(o), t.attr("aria-labelledby", n.attr("id"))
            }), t = n.add(this.element), t.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role", "presentation").children("a").uniqueId().addClass("ui-corner-all").attr({
                tabIndex: -1,
                role: this._itemRole()
            }), t.children(":not(.ui-menu-item)").each(function() {
                var t = e(this);
                /[^\-\u2014\u2013\s]/.test(t.text()) || t.addClass("ui-widget-content ui-menu-divider")
            }), t.children(".ui-state-disabled").attr("aria-disabled", "true"), this.active && !e.contains(this.element[0], this.active[0]) && this.blur()
        },
        _itemRole: function() {
            return {
                menu: "menuitem",
                listbox: "option"
            }[this.options.role]
        },
        _setOption: function(e, t) {
            "icons" === e && this.element.find(".ui-menu-icon").removeClass(this.options.icons.submenu).addClass(t.submenu), this._super(e, t)
        },
        focus: function(e, t) {
            var i, n;
            this.blur(e, e && "focus" === e.type), this._scrollIntoView(t), this.active = t.first(), n = this.active.children("a").addClass("ui-state-focus"), this.options.role && this.element.attr("aria-activedescendant", n.attr("id")), this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"), e && "keydown" === e.type ? this._close() : this.timer = this._delay(function() {
                this._close()
            }, this.delay), i = t.children(".ui-menu"), i.length && e && /^mouse/.test(e.type) && this._startOpening(i), this.activeMenu = t.parent(), this._trigger("focus", e, {
                item: t
            })
        },
        _scrollIntoView: function(t) {
            var i, n, o, s, r, a;
            this._hasScroll() && (i = parseFloat(e.css(this.activeMenu[0], "borderTopWidth")) || 0, n = parseFloat(e.css(this.activeMenu[0], "paddingTop")) || 0, o = t.offset().top - this.activeMenu.offset().top - i - n, s = this.activeMenu.scrollTop(), r = this.activeMenu.height(), a = t.height(), 0 > o ? this.activeMenu.scrollTop(s + o) : o + a > r && this.activeMenu.scrollTop(s + o - r + a))
        },
        blur: function(e, t) {
            t || clearTimeout(this.timer), this.active && (this.active.children("a").removeClass("ui-state-focus"), this.active = null, this._trigger("blur", e, {
                item: this.active
            }))
        },
        _startOpening: function(e) {
            clearTimeout(this.timer), "true" === e.attr("aria-hidden") && (this.timer = this._delay(function() {
                this._close(), this._open(e)
            }, this.delay))
        },
        _open: function(t) {
            var i = e.extend({
                of: this.active
            }, this.options.position);
            clearTimeout(this.timer), this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden", "true"), t.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(i)
        },
        collapseAll: function(t, i) {
            clearTimeout(this.timer), this.timer = this._delay(function() {
                var n = i ? this.element : e(t && t.target).closest(this.element.find(".ui-menu"));
                n.length || (n = this.element), this._close(n), this.blur(t), this.activeMenu = n
            }, this.delay)
        },
        _close: function(e) {
            e || (e = this.active ? this.active.parent() : this.element), e.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false").end().find("a.ui-state-active").removeClass("ui-state-active")
        },
        collapse: function(e) {
            var t = this.active && this.active.parent().closest(".ui-menu-item", this.element);
            t && t.length && (this._close(), this.focus(e, t))
        },
        expand: function(e) {
            var t = this.active && this.active.children(".ui-menu ").children(".ui-menu-item").first();
            t && t.length && (this._open(t.parent()), this._delay(function() {
                this.focus(e, t)
            }))
        },
        next: function(e) {
            this._move("next", "first", e)
        },
        previous: function(e) {
            this._move("prev", "last", e)
        },
        isFirstItem: function() {
            return this.active && !this.active.prevAll(".ui-menu-item").length
        },
        isLastItem: function() {
            return this.active && !this.active.nextAll(".ui-menu-item").length
        },
        _move: function(e, t, i) {
            var n;
            this.active && (n = "first" === e || "last" === e ? this.active["first" === e ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1) : this.active[e + "All"](".ui-menu-item").eq(0)), n && n.length && this.active || (n = this.activeMenu.children(".ui-menu-item")[t]()), this.focus(i, n)
        },
        nextPage: function(t) {
            var i, n, o;
            return this.active ? void(this.isLastItem() || (this._hasScroll() ? (n = this.active.offset().top, o = this.element.height(), this.active.nextAll(".ui-menu-item").each(function() {
                return i = e(this), 0 > i.offset().top - n - o
            }), this.focus(t, i)) : this.focus(t, this.activeMenu.children(".ui-menu-item")[this.active ? "last" : "first"]()))) : void this.next(t)
        },
        previousPage: function(t) {
            var i, n, o;
            return this.active ? void(this.isFirstItem() || (this._hasScroll() ? (n = this.active.offset().top, o = this.element.height(), this.active.prevAll(".ui-menu-item").each(function() {
                return i = e(this), i.offset().top - n + o > 0
            }), this.focus(t, i)) : this.focus(t, this.activeMenu.children(".ui-menu-item").first()))) : void this.next(t)
        },
        _hasScroll: function() {
            return this.element.outerHeight() < this.element.prop("scrollHeight")
        },
        select: function(t) {
            this.active = this.active || e(t.target).closest(".ui-menu-item");
            var i = {
                item: this.active
            };
            this.active.has(".ui-menu").length || this.collapseAll(t, !0), this._trigger("select", t, i)
        }
    })
}(jQuery),
function(e) {
    e.isScrollToFixed = function(t) {
        return !!e(t).data("ScrollToFixed")
    }, e.ScrollToFixed = function(t, i) {
        function n() {
            w.trigger("preUnfixed.ScrollToFixed"), c(), w.trigger("unfixed.ScrollToFixed"), D = -1, T = w.offset().top, E = w.offset().left, v.options.offsets && (E += w.offset().left - w.position().left), -1 == C && (C = E), g = w.css("position"), x = !0, -1 != v.options.bottom && (w.trigger("preFixed.ScrollToFixed"), u(), w.trigger("fixed.ScrollToFixed"))
        }

        function o() {
            var e = v.options.limit;
            return e ? "function" == typeof e ? e.apply(w) : e : 0
        }

        function s() {
            return "fixed" === g
        }

        function r() {
            return "absolute" === g
        }

        function a() {
            return !(s() || r())
        }

        function u() {
            s() || (S.css({
                display: w.css("display"),
                width: w.outerWidth(!0),
                height: w.outerHeight(!0),
                "float": w.css("float")
            }), cssOptions = {
                "z-index": v.options.zIndex,
                position: "fixed",
                top: -1 == v.options.bottom ? d() : "",
                bottom: -1 == v.options.bottom ? "" : v.options.bottom,
                "margin-left": "0px"
            }, v.options.dontSetWidth || (cssOptions.width = w.width()), w.css(cssOptions), w.addClass(v.options.baseClassName), v.options.className && w.addClass(v.options.className), g = "fixed")
        }

        function l() {
            var e = o(),
                t = E;
            v.options.removeOffsets && (t = "", e -= T), cssOptions = {
                position: "absolute",
                top: e,
                left: t,
                "margin-left": "0px",
                bottom: ""
            }, v.options.dontSetWidth || (cssOptions.width = w.width()), w.css(cssOptions), g = "absolute"
        }

        function c() {
            a() || (D = -1, S.css("display", "none"), w.css({
                "z-index": _,
                width: "",
                position: b,
                left: "",
                top: y,
                "margin-left": ""
            }), w.removeClass("scroll-to-fixed-fixed"), v.options.className && w.removeClass(v.options.className), g = null)
        }

        function h(e) {
            e != D && (w.css("left", E - e), D = e)
        }

        function d() {
            var e = v.options.marginTop;
            return e ? "function" == typeof e ? e.apply(w) : e : 0
        }

        function f() {
            if (e.isScrollToFixed(w)) {
                var t = x;
                x ? a() && (T = w.offset().top, E = w.offset().left) : n();
                var i = e(window).scrollLeft(),
                    f = e(window).scrollTop(),
                    g = o();
                v.options.minWidth && e(window).width() < v.options.minWidth ? a() && t || (m(), w.trigger("preUnfixed.ScrollToFixed"), c(), w.trigger("unfixed.ScrollToFixed")) : v.options.maxWidth && e(window).width() > v.options.maxWidth ? a() && t || (m(), w.trigger("preUnfixed.ScrollToFixed"), c(), w.trigger("unfixed.ScrollToFixed")) : -1 == v.options.bottom ? g > 0 && f >= g - d() ? r() && t || (m(), w.trigger("preAbsolute.ScrollToFixed"), l(), w.trigger("unfixed.ScrollToFixed")) : f >= T - d() ? (s() && t || (m(), w.trigger("preFixed.ScrollToFixed"), u(), D = -1, w.trigger("fixed.ScrollToFixed")), h(i)) : a() && t || (m(), w.trigger("preUnfixed.ScrollToFixed"), c(), w.trigger("unfixed.ScrollToFixed")) : g > 0 ? f + e(window).height() - w.outerHeight(!0) >= g - (d() || -p()) ? s() && (m(), w.trigger("preUnfixed.ScrollToFixed"), "absolute" === b ? l() : c(), w.trigger("unfixed.ScrollToFixed")) : (s() || (m(), w.trigger("preFixed.ScrollToFixed"), u()), h(i), w.trigger("fixed.ScrollToFixed")) : h(i)
            }
        }

        function p() {
            return v.options.bottom ? v.options.bottom : 0
        }

        function m() {
            var e = w.css("position");
            w.trigger("absolute" == e ? "postAbsolute.ScrollToFixed" : "fixed" == e ? "postFixed.ScrollToFixed" : "postUnfixed.ScrollToFixed")
        }
        var v = this;
        v.$el = e(t), v.el = t, v.$el.data("ScrollToFixed", v);
        var g, b, y, _, x = !1,
            w = v.$el,
            T = 0,
            E = 0,
            C = -1,
            D = -1,
            S = null,
            A = function() {
                w.is(":visible") && (x = !1, f())
            },
            F = function() {
                window.requestAnimationFrame ? requestAnimationFrame(f) : f()
            },
            N = function(e) {
                e = e || window.event, e.preventDefault && e.preventDefault(), e.returnValue = !1
            };
        v.init = function() {
            v.options = e.extend({}, e.ScrollToFixed.defaultOptions, i), _ = w.css("z-index"), v.$el.css("z-index", v.options.zIndex), S = e("<div />"), g = w.css("position"), b = w.css("position"), y = w.css("top"), a() && v.$el.after(S), e(window).bind("resize.ScrollToFixed", A), e(window).bind("scroll.ScrollToFixed", F), "ontouchmove" in window && e(window).bind("touchmove.ScrollToFixed", f), v.options.preFixed && w.bind("preFixed.ScrollToFixed", v.options.preFixed), v.options.postFixed && w.bind("postFixed.ScrollToFixed", v.options.postFixed), v.options.preUnfixed && w.bind("preUnfixed.ScrollToFixed", v.options.preUnfixed), v.options.postUnfixed && w.bind("postUnfixed.ScrollToFixed", v.options.postUnfixed), v.options.preAbsolute && w.bind("preAbsolute.ScrollToFixed", v.options.preAbsolute), v.options.postAbsolute && w.bind("postAbsolute.ScrollToFixed", v.options.postAbsolute), v.options.fixed && w.bind("fixed.ScrollToFixed", v.options.fixed), v.options.unfixed && w.bind("unfixed.ScrollToFixed", v.options.unfixed), v.options.spacerClass && S.addClass(v.options.spacerClass), w.bind("resize.ScrollToFixed", function() {
                S.height(w.height())
            }), w.bind("scroll.ScrollToFixed", function() {
                w.trigger("preUnfixed.ScrollToFixed"), c(), w.trigger("unfixed.ScrollToFixed"), f()
            }), w.bind("detach.ScrollToFixed", function(t) {
                N(t), w.trigger("preUnfixed.ScrollToFixed"), c(), w.trigger("unfixed.ScrollToFixed"), e(window).unbind("resize.ScrollToFixed", A), e(window).unbind("scroll.ScrollToFixed", F), w.unbind(".ScrollToFixed"), S.remove(), v.$el.removeData("ScrollToFixed")
            }), A()
        }, v.init()
    }, e.ScrollToFixed.defaultOptions = {
        marginTop: 0,
        limit: 0,
        bottom: -1,
        zIndex: 1e3,
        baseClassName: "scroll-to-fixed-fixed"
    }, e.fn.scrollToFixed = function(t) {
        return this.each(function() {
            new e.ScrollToFixed(this, t)
        })
    }
}(jQuery),
function() {
    function e() {}

    function t(e, t) {
        for (var i = e.length; i--;)
            if (e[i].listener === t) return i;
        return -1
    }

    function i(e) {
        return function() {
            return this[e].apply(this, arguments)
        }
    }
    var n = e.prototype,
        o = this,
        s = o.EventEmitter;
    n.getListeners = function(e) {
        var t, i, n = this._getEvents();
        if ("object" == typeof e) {
            t = {};
            for (i in n) n.hasOwnProperty(i) && e.test(i) && (t[i] = n[i])
        } else t = n[e] || (n[e] = []);
        return t
    }, n.flattenListeners = function(e) {
        var t, i = [];
        for (t = 0; e.length > t; t += 1) i.push(e[t].listener);
        return i
    }, n.getListenersAsObject = function(e) {
        var t, i = this.getListeners(e);
        return i instanceof Array && (t = {}, t[e] = i), t || i
    }, n.addListener = function(e, i) {
        var n, o = this.getListenersAsObject(e),
            s = "object" == typeof i;
        for (n in o) o.hasOwnProperty(n) && -1 === t(o[n], i) && o[n].push(s ? i : {
            listener: i,
            once: !1
        });
        return this
    }, n.on = i("addListener"), n.addOnceListener = function(e, t) {
        return this.addListener(e, {
            listener: t,
            once: !0
        })
    }, n.once = i("addOnceListener"), n.defineEvent = function(e) {
        return this.getListeners(e), this
    }, n.defineEvents = function(e) {
        for (var t = 0; e.length > t; t += 1) this.defineEvent(e[t]);
        return this
    }, n.removeListener = function(e, i) {
        var n, o, s = this.getListenersAsObject(e);
        for (o in s) s.hasOwnProperty(o) && (n = t(s[o], i), -1 !== n && s[o].splice(n, 1));
        return this
    }, n.off = i("removeListener"), n.addListeners = function(e, t) {
        return this.manipulateListeners(!1, e, t)
    }, n.removeListeners = function(e, t) {
        return this.manipulateListeners(!0, e, t)
    }, n.manipulateListeners = function(e, t, i) {
        var n, o, s = e ? this.removeListener : this.addListener,
            r = e ? this.removeListeners : this.addListeners;
        if ("object" != typeof t || t instanceof RegExp)
            for (n = i.length; n--;) s.call(this, t, i[n]);
        else
            for (n in t) t.hasOwnProperty(n) && (o = t[n]) && ("function" == typeof o ? s.call(this, n, o) : r.call(this, n, o));
        return this
    }, n.removeEvent = function(e) {
        var t, i = typeof e,
            n = this._getEvents();
        if ("string" === i) delete n[e];
        else if ("object" === i)
            for (t in n) n.hasOwnProperty(t) && e.test(t) && delete n[t];
        else delete this._events;
        return this
    }, n.removeAllListeners = i("removeEvent"), n.emitEvent = function(e, t) {
        var i, n, o, s, r = this.getListenersAsObject(e);
        for (o in r)
            if (r.hasOwnProperty(o))
                for (n = r[o].length; n--;) i = r[o][n], i.once === !0 && this.removeListener(e, i.listener), s = i.listener.apply(this, t || []), s === this._getOnceReturnValue() && this.removeListener(e, i.listener);
        return this
    }, n.trigger = i("emitEvent"), n.emit = function(e) {
        var t = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(e, t)
    }, n.setOnceReturnValue = function(e) {
        return this._onceReturnValue = e, this
    }, n._getOnceReturnValue = function() {
        return this.hasOwnProperty("_onceReturnValue") ? this._onceReturnValue : !0
    }, n._getEvents = function() {
        return this._events || (this._events = {})
    }, e.noConflict = function() {
        return o.EventEmitter = s, e
    }, "function" == typeof define && define.amd ? define("eventEmitter/EventEmitter", [], function() {
        return e
    }) : "object" == typeof module && module.exports ? module.exports = e : this.EventEmitter = e
}.call(this),
    function(e) {
        var t = document.documentElement,
            i = function() {};
        t.addEventListener ? i = function(e, t, i) {
            e.addEventListener(t, i, !1)
        } : t.attachEvent && (i = function(t, i, n) {
            t[i + n] = n.handleEvent ? function() {
                var t = e.event;
                t.target = t.target || t.srcElement, n.handleEvent.call(n, t)
            } : function() {
                var i = e.event;
                i.target = i.target || i.srcElement, n.call(t, i)
            }, t.attachEvent("on" + i, t[i + n])
        });
        var n = function() {};
        t.removeEventListener ? n = function(e, t, i) {
            e.removeEventListener(t, i, !1)
        } : t.detachEvent && (n = function(e, t, i) {
            e.detachEvent("on" + t, e[t + i]);
            try {
                delete e[t + i]
            } catch (n) {
                e[t + i] = void 0
            }
        });
        var o = {
            bind: i,
            unbind: n
        };
        "function" == typeof define && define.amd ? define("eventie/eventie", o) : e.eventie = o
    }(this),
    function(e) {
        function t(e, t) {
            for (var i in t) e[i] = t[i];
            return e
        }

        function i(e) {
            return "[object Array]" === u.call(e)
        }

        function n(e) {
            var t = [];
            if (i(e)) t = e;
            else if ("number" == typeof e.length)
                for (var n = 0, o = e.length; o > n; n++) t.push(e[n]);
            else t.push(e);
            return t
        }

        function o(e, i) {
            function o(e, i, r) {
                if (!(this instanceof o)) return new o(e, i);
                "string" == typeof e && (e = document.querySelectorAll(e)), this.elements = n(e), this.options = t({}, this.options), "function" == typeof i ? r = i : t(this.options, i), r && this.on("always", r), this.getImages(), s && (this.jqDeferred = new s.Deferred);
                var a = this;
                setTimeout(function() {
                    a.check()
                })
            }

            function u(e) {
                this.img = e
            }

            function l(e) {
                this.src = e, c[e] = this
            }
            o.prototype = new e, o.prototype.options = {}, o.prototype.getImages = function() {
                this.images = [];
                for (var e = 0, t = this.elements.length; t > e; e++) {
                    var i = this.elements[e];
                    "IMG" === i.nodeName && this.addImage(i);
                    for (var n = i.querySelectorAll("img"), o = 0, s = n.length; s > o; o++) {
                        var r = n[o];
                        this.addImage(r)
                    }
                }
            }, o.prototype.addImage = function(e) {
                var t = new u(e);
                this.images.push(t)
            }, o.prototype.check = function() {
                function e(e, o) {
                    return t.options.debug && a && r.log("confirm", e, o), t.progress(e), i++, i === n && t.complete(), !0
                }
                var t = this,
                    i = 0,
                    n = this.images.length;
                if (this.hasAnyBroken = !1, !n) return void this.complete();
                for (var o = 0; n > o; o++) {
                    var s = this.images[o];
                    s.on("confirm", e), s.check()
                }
            }, o.prototype.progress = function(e) {
                this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded;
                var t = this;
                setTimeout(function() {
                    t.emit("progress", t, e), t.jqDeferred && t.jqDeferred.notify(t, e)
                })
            }, o.prototype.complete = function() {
                var e = this.hasAnyBroken ? "fail" : "done";
                this.isComplete = !0;
                var t = this;
                setTimeout(function() {
                    if (t.emit(e, t), t.emit("always", t), t.jqDeferred) {
                        var i = t.hasAnyBroken ? "reject" : "resolve";
                        t.jqDeferred[i](t)
                    }
                })
            }, s && (s.fn.imagesLoaded = function(e, t) {
                var i = new o(this, e, t);
                return i.jqDeferred.promise(s(this))
            }), u.prototype = new e, u.prototype.check = function() {
                var e = c[this.img.src] || new l(this.img.src);
                if (e.isConfirmed) return void this.confirm(e.isLoaded, "cached was confirmed");
                if (this.img.complete && void 0 !== this.img.naturalWidth) return void this.confirm(0 !== this.img.naturalWidth, "naturalWidth");
                var t = this;
                e.on("confirm", function(e, i) {
                    return t.confirm(e.isLoaded, i), !0
                }), e.check()
            }, u.prototype.confirm = function(e, t) {
                this.isLoaded = e, this.emit("confirm", this, t)
            };
            var c = {};
            return l.prototype = new e, l.prototype.check = function() {
                if (!this.isChecked) {
                    var e = new Image;
                    i.bind(e, "load", this), i.bind(e, "error", this), e.src = this.src, this.isChecked = !0
                }
            }, l.prototype.handleEvent = function(e) {
                var t = "on" + e.type;
                this[t] && this[t](e)
            }, l.prototype.onload = function(e) {
                this.confirm(!0, "onload"), this.unbindProxyEvents(e)
            }, l.prototype.onerror = function(e) {
                this.confirm(!1, "onerror"), this.unbindProxyEvents(e)
            }, l.prototype.confirm = function(e, t) {
                this.isConfirmed = !0, this.isLoaded = e, this.emit("confirm", this, t)
            }, l.prototype.unbindProxyEvents = function(e) {
                i.unbind(e.target, "load", this), i.unbind(e.target, "error", this)
            }, o
        }
        var s = e.jQuery,
            r = e.console,
            a = void 0 !== r,
            u = Object.prototype.toString;
        "function" == typeof define && define.amd ? define(["eventEmitter/EventEmitter", "eventie/eventie"], o) : e.imagesLoaded = o(e.EventEmitter, e.eventie)
    }(window), ! function(e) {
        "use strict";

        function t(e, t) {
            var i = (65535 & e) + (65535 & t),
                n = (e >> 16) + (t >> 16) + (i >> 16);
            return n << 16 | 65535 & i
        }

        function i(e, t) {
            return e << t | e >>> 32 - t
        }

        function n(e, n, o, s, r, a) {
            return t(i(t(t(n, e), t(s, a)), r), o)
        }

        function o(e, t, i, o, s, r, a) {
            return n(t & i | ~t & o, e, t, s, r, a)
        }

        function s(e, t, i, o, s, r, a) {
            return n(t & o | i & ~o, e, t, s, r, a)
        }

        function r(e, t, i, o, s, r, a) {
            return n(t ^ i ^ o, e, t, s, r, a)
        }

        function a(e, t, i, o, s, r, a) {
            return n(i ^ (t | ~o), e, t, s, r, a)
        }

        function u(e, i) {
            e[i >> 5] |= 128 << i % 32, e[(i + 64 >>> 9 << 4) + 14] = i;
            var n, u, l, c, h, d = 1732584193,
                f = -271733879,
                p = -1732584194,
                m = 271733878;
            for (n = 0; n < e.length; n += 16) u = d, l = f, c = p, h = m, d = o(d, f, p, m, e[n], 7, -680876936), m = o(m, d, f, p, e[n + 1], 12, -389564586), p = o(p, m, d, f, e[n + 2], 17, 606105819), f = o(f, p, m, d, e[n + 3], 22, -1044525330), d = o(d, f, p, m, e[n + 4], 7, -176418897), m = o(m, d, f, p, e[n + 5], 12, 1200080426), p = o(p, m, d, f, e[n + 6], 17, -1473231341), f = o(f, p, m, d, e[n + 7], 22, -45705983), d = o(d, f, p, m, e[n + 8], 7, 1770035416), m = o(m, d, f, p, e[n + 9], 12, -1958414417), p = o(p, m, d, f, e[n + 10], 17, -42063), f = o(f, p, m, d, e[n + 11], 22, -1990404162), d = o(d, f, p, m, e[n + 12], 7, 1804603682), m = o(m, d, f, p, e[n + 13], 12, -40341101), p = o(p, m, d, f, e[n + 14], 17, -1502002290), f = o(f, p, m, d, e[n + 15], 22, 1236535329), d = s(d, f, p, m, e[n + 1], 5, -165796510), m = s(m, d, f, p, e[n + 6], 9, -1069501632), p = s(p, m, d, f, e[n + 11], 14, 643717713), f = s(f, p, m, d, e[n], 20, -373897302), d = s(d, f, p, m, e[n + 5], 5, -701558691), m = s(m, d, f, p, e[n + 10], 9, 38016083), p = s(p, m, d, f, e[n + 15], 14, -660478335), f = s(f, p, m, d, e[n + 4], 20, -405537848), d = s(d, f, p, m, e[n + 9], 5, 568446438), m = s(m, d, f, p, e[n + 14], 9, -1019803690), p = s(p, m, d, f, e[n + 3], 14, -187363961), f = s(f, p, m, d, e[n + 8], 20, 1163531501), d = s(d, f, p, m, e[n + 13], 5, -1444681467), m = s(m, d, f, p, e[n + 2], 9, -51403784), p = s(p, m, d, f, e[n + 7], 14, 1735328473), f = s(f, p, m, d, e[n + 12], 20, -1926607734), d = r(d, f, p, m, e[n + 5], 4, -378558), m = r(m, d, f, p, e[n + 8], 11, -2022574463), p = r(p, m, d, f, e[n + 11], 16, 1839030562), f = r(f, p, m, d, e[n + 14], 23, -35309556), d = r(d, f, p, m, e[n + 1], 4, -1530992060), m = r(m, d, f, p, e[n + 4], 11, 1272893353), p = r(p, m, d, f, e[n + 7], 16, -155497632), f = r(f, p, m, d, e[n + 10], 23, -1094730640), d = r(d, f, p, m, e[n + 13], 4, 681279174), m = r(m, d, f, p, e[n], 11, -358537222), p = r(p, m, d, f, e[n + 3], 16, -722521979), f = r(f, p, m, d, e[n + 6], 23, 76029189), d = r(d, f, p, m, e[n + 9], 4, -640364487), m = r(m, d, f, p, e[n + 12], 11, -421815835), p = r(p, m, d, f, e[n + 15], 16, 530742520), f = r(f, p, m, d, e[n + 2], 23, -995338651), d = a(d, f, p, m, e[n], 6, -198630844), m = a(m, d, f, p, e[n + 7], 10, 1126891415), p = a(p, m, d, f, e[n + 14], 15, -1416354905), f = a(f, p, m, d, e[n + 5], 21, -57434055), d = a(d, f, p, m, e[n + 12], 6, 1700485571), m = a(m, d, f, p, e[n + 3], 10, -1894986606), p = a(p, m, d, f, e[n + 10], 15, -1051523), f = a(f, p, m, d, e[n + 1], 21, -2054922799), d = a(d, f, p, m, e[n + 8], 6, 1873313359), m = a(m, d, f, p, e[n + 15], 10, -30611744), p = a(p, m, d, f, e[n + 6], 15, -1560198380), f = a(f, p, m, d, e[n + 13], 21, 1309151649), d = a(d, f, p, m, e[n + 4], 6, -145523070), m = a(m, d, f, p, e[n + 11], 10, -1120210379), p = a(p, m, d, f, e[n + 2], 15, 718787259), f = a(f, p, m, d, e[n + 9], 21, -343485551), d = t(d, u), f = t(f, l), p = t(p, c), m = t(m, h);
            return [d, f, p, m]
        }

        function l(e) {
            var t, i = "";
            for (t = 0; t < 32 * e.length; t += 8) i += String.fromCharCode(e[t >> 5] >>> t % 32 & 255);
            return i
        }

        function c(e) {
            var t, i = [];
            for (i[(e.length >> 2) - 1] = void 0, t = 0; t < i.length; t += 1) i[t] = 0;
            for (t = 0; t < 8 * e.length; t += 8) i[t >> 5] |= (255 & e.charCodeAt(t / 8)) << t % 32;
            return i
        }

        function h(e) {
            return l(u(c(e), 8 * e.length))
        }

        function d(e, t) {
            var i, n, o = c(e),
                s = [],
                r = [];
            for (s[15] = r[15] = void 0, o.length > 16 && (o = u(o, 8 * e.length)), i = 0; 16 > i; i += 1) s[i] = 909522486 ^ o[i], r[i] = 1549556828 ^ o[i];
            return n = u(s.concat(c(t)), 512 + 8 * t.length), l(u(r.concat(n), 640))
        }

        function f(e) {
            var t, i, n = "0123456789abcdef",
                o = "";
            for (i = 0; i < e.length; i += 1) t = e.charCodeAt(i), o += n.charAt(t >>> 4 & 15) + n.charAt(15 & t);
            return o
        }

        function p(e) {
            return unescape(encodeURIComponent(e))
        }

        function m(e) {
            return h(p(e))
        }

        function v(e) {
            return f(m(e))
        }

        function g(e, t) {
            return d(p(e), p(t))
        }

        function b(e, t) {
            return f(g(e, t))
        }

        function y(e, t, i) {
            return t ? i ? g(t, e) : b(t, e) : i ? m(e) : v(e)
        }
        "function" == typeof define && define.amd ? define(function() {
            return y
        }) : e.md5 = y
    }(this);
j = "jQuery", y = $("meta[name='ld']").attr("content"), e = $("meta[name='l']").attr("content"), $$$ = "flexSlider v hwMCMNbtUG6 More things";
! function(e) {
    e.fn.hoverIntent = function(t, n, i) {
        var a = {
            interval: 100,
            sensitivity: 6,
            timeout: 0
        };
        a = "object" == typeof t ? e.extend(a, t) : e.isFunction(n) ? e.extend(a, {
            over: t,
            out: n,
            selector: i
        }) : e.extend(a, {
            over: t,
            out: t,
            selector: n
        });
        var o, r, s, l, c = function(e) {
                o = e.pageX, r = e.pageY
            },
            d = function(t, n) {
                return n.hoverIntent_t = clearTimeout(n.hoverIntent_t), Math.sqrt((s - o) * (s - o) + (l - r) * (l - r)) < a.sensitivity ? (e(n).off("mousemove.hoverIntent", c), n.hoverIntent_s = !0, a.over.apply(n, [t])) : (s = o, l = r, n.hoverIntent_t = setTimeout(function() {
                    d(t, n)
                }, a.interval), void 0)
            },
            u = function(e, t) {
                return t.hoverIntent_t = clearTimeout(t.hoverIntent_t), t.hoverIntent_s = !1, a.out.apply(t, [e])
            },
            p = function(t) {
                var n = e.extend({}, t),
                    i = this;
                i.hoverIntent_t && (i.hoverIntent_t = clearTimeout(i.hoverIntent_t)), "mouseenter" === t.type ? (s = n.pageX, l = n.pageY, e(i).on("mousemove.hoverIntent", c), i.hoverIntent_s || (i.hoverIntent_t = setTimeout(function() {
                    d(n, i)
                }, a.interval))) : (e(i).off("mousemove.hoverIntent", c), i.hoverIntent_s && (i.hoverIntent_t = setTimeout(function() {
                    u(n, i)
                }, a.timeout)))
            };
        return this.on({
            "mouseenter.hoverIntent": p,
            "mouseleave.hoverIntent": p
        }, a.selector)
    }
}(jQuery), window.Modernizr = function(e, t, n) {
        function i(e) {
            h.cssText = e
        }

        function a(e, t) {
            return typeof e === t
        }
        var o, r, s, l = "2.6.2",
            c = {},
            d = !0,
            u = t.documentElement,
            p = "modernizr",
            f = t.createElement(p),
            h = f.style,
            v = ({}.toString, " -webkit- -moz- -o- -ms- ".split(" ")),
            m = {},
            g = [],
            y = g.slice,
            x = function(e, n, i, a) {
                var o, r, s, l, c = t.createElement("div"),
                    d = t.body,
                    f = d || t.createElement("body");
                if (parseInt(i, 10))
                    for (; i--;) s = t.createElement("div"), s.id = a ? a[i] : p + (i + 1), c.appendChild(s);
                return o = ["&#173;", '<style id="s', p, '">', e, "</style>"].join(""), c.id = p, (d ? c : f).innerHTML += o, f.appendChild(c), d || (f.style.background = "", f.style.overflow = "hidden", l = u.style.overflow, u.style.overflow = "hidden", u.appendChild(f)), r = n(c, e), d ? c.parentNode.removeChild(c) : (f.parentNode.removeChild(f), u.style.overflow = l), !!r
            },
            b = {}.hasOwnProperty;
        s = a(b, "undefined") || a(b.call, "undefined") ? function(e, t) {
            return t in e && a(e.constructor.prototype[t], "undefined")
        } : function(e, t) {
            return b.call(e, t)
        }, Function.prototype.bind || (Function.prototype.bind = function(e) {
            var t = this;
            if ("function" != typeof t) throw new TypeError;
            var n = y.call(arguments, 1),
                i = function() {
                    if (this instanceof i) {
                        var a = function() {};
                        a.prototype = t.prototype;
                        var o = new a,
                            r = t.apply(o, n.concat(y.call(arguments)));
                        return Object(r) === r ? r : o
                    }
                    return t.apply(e, n.concat(y.call(arguments)))
                };
            return i
        }), m.touch = function() {
            var n;
            return "ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch ? n = !0 : x(["@media (", v.join("touch-enabled),("), p, ")", "{#modernizr{top:9px;position:absolute}}"].join(""), function(e) {
                n = 9 === e.offsetTop
            }), n
        };
        for (var w in m) s(m, w) && (r = w.toLowerCase(), c[r] = m[w](), g.push((c[r] ? "" : "no-") + r));
        return c.addTest = function(e, t) {
                if ("object" == typeof e)
                    for (var i in e) s(e, i) && c.addTest(i, e[i]);
                else {
                    if (e = e.toLowerCase(), c[e] !== n) return c;
                    t = "function" == typeof t ? t() : t, "undefined" != typeof d && d && (u.className += " " + (t ? "" : "no-") + e), c[e] = t
                }
                return c
            }, i(""), f = o = null,
            function(e, t) {
                function n(e, t) {
                    var n = e.createElement("p"),
                        i = e.getElementsByTagName("head")[0] || e.documentElement;
                    return n.innerHTML = "x<style>" + t + "</style>", i.insertBefore(n.lastChild, i.firstChild)
                }

                function i() {
                    var e = g.elements;
                    return "string" == typeof e ? e.split(" ") : e
                }

                function a(e) {
                    var t = m[e[h]];
                    return t || (t = {}, v++, e[h] = v, m[v] = t), t
                }

                function o(e, n, i) {
                    if (n || (n = t), d) return n.createElement(e);
                    i || (i = a(n));
                    var o;
                    return o = i.cache[e] ? i.cache[e].cloneNode() : f.test(e) ? (i.cache[e] = i.createElem(e)).cloneNode() : i.createElem(e), o.canHaveChildren && !p.test(e) ? i.frag.appendChild(o) : o
                }

                function r(e, n) {
                    if (e || (e = t), d) return e.createDocumentFragment();
                    n = n || a(e);
                    for (var o = n.frag.cloneNode(), r = 0, s = i(), l = s.length; l > r; r++) o.createElement(s[r]);
                    return o
                }

                function s(e, t) {
                    t.cache || (t.cache = {}, t.createElem = e.createElement, t.createFrag = e.createDocumentFragment, t.frag = t.createFrag()), e.createElement = function(n) {
                        return g.shivMethods ? o(n, e, t) : t.createElem(n)
                    }, e.createDocumentFragment = Function("h,f", "return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&(" + i().join().replace(/\w+/g, function(e) {
                        return t.createElem(e), t.frag.createElement(e), 'c("' + e + '")'
                    }) + ");return n}")(g, t.frag)
                }

                function l(e) {
                    e || (e = t);
                    var i = a(e);
                    return g.shivCSS && !c && !i.hasCSS && (i.hasCSS = !!n(e, "article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}mark{background:#FF0;color:#000}")), d || s(e, i), e
                }
                var c, d, u = e.html5 || {},
                    p = /^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,
                    f = /^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,
                    h = "_html5shiv",
                    v = 0,
                    m = {};
                ! function() {
                    try {
                        var e = t.createElement("a");
                        e.innerHTML = "<xyz></xyz>", c = "hidden" in e, d = 1 == e.childNodes.length || function() {
                            t.createElement("a");
                            var e = t.createDocumentFragment();
                            return "undefined" == typeof e.cloneNode || "undefined" == typeof e.createDocumentFragment || "undefined" == typeof e.createElement
                        }()
                    } catch (n) {
                        c = !0, d = !0
                    }
                }();
                var g = {
                    elements: u.elements || "abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video",
                    shivCSS: u.shivCSS !== !1,
                    supportsUnknownElements: d,
                    shivMethods: u.shivMethods !== !1,
                    type: "default",
                    shivDocument: l,
                    createElement: o,
                    createDocumentFragment: r
                };
                e.html5 = g, l(t)
            }(this, t), c._version = l, c._prefixes = v, c.testStyles = x, u.className = u.className.replace(/(^|\s)no-js(\s|$)/, "$1$2") + (d ? " js " + g.join(" ") : ""), c
    }(this, this.document),
    function(e, t, n) {
        function i(e) {
            return "[object Function]" == m.call(e)
        }

        function a(e) {
            return "string" == typeof e
        }

        function o() {}

        function r(e) {
            return !e || "loaded" == e || "complete" == e || "uninitialized" == e
        }

        function s() {
            var e = g.shift();
            y = 1, e ? e.t ? h(function() {
                ("c" == e.t ? p.injectCss : p.injectJs)(e.s, 0, e.a, e.x, e.e, 1)
            }, 0) : (e(), s()) : y = 0
        }

        function l(e, n, i, a, o, l, c) {
            function d(t) {
                if (!f && r(u.readyState) && (x.r = f = 1, !y && s(), u.onload = u.onreadystatechange = null, t)) {
                    "img" != e && h(function() {
                        w.removeChild(u)
                    }, 50);
                    for (var i in k[n]) k[n].hasOwnProperty(i) && k[n][i].onload()
                }
            }
            var c = c || p.errorTimeout,
                u = t.createElement(e),
                f = 0,
                m = 0,
                x = {
                    t: i,
                    s: n,
                    e: o,
                    a: l,
                    x: c
                };
            1 === k[n] && (m = 1, k[n] = []), "object" == e ? u.data = n : (u.src = n, u.type = e), u.width = u.height = "0", u.onerror = u.onload = u.onreadystatechange = function() {
                d.call(this, m)
            }, g.splice(a, 0, x), "img" != e && (m || 2 === k[n] ? (w.insertBefore(u, b ? null : v), h(d, c)) : k[n].push(u))
        }

        function c(e, t, n, i, o) {
            return y = 0, t = t || "j", a(e) ? l("c" == t ? C : S, e, t, this.i++, n, i, o) : (g.splice(this.i++, 0, e), 1 == g.length && s()), this
        }

        function d() {
            var e = p;
            return e.loader = {
                load: c,
                i: 0
            }, e
        }
        var u, p, f = t.documentElement,
            h = e.setTimeout,
            v = t.getElementsByTagName("script")[0],
            m = {}.toString,
            g = [],
            y = 0,
            x = "MozAppearance" in f.style,
            b = x && !!t.createRange().compareNode,
            w = b ? f : v.parentNode,
            f = e.opera && "[object Opera]" == m.call(e.opera),
            f = !!t.attachEvent && !f,
            S = x ? "object" : f ? "script" : "img",
            C = f ? "script" : S,
            T = Array.isArray || function(e) {
                return "[object Array]" == m.call(e)
            },
            E = [],
            k = {},
            P = {
                timeout: function(e, t) {
                    return t.length && (e.timeout = t[0]), e
                }
            };
        p = function(e) {
            function t(e) {
                var t, n, i, e = e.split("!"),
                    a = E.length,
                    o = e.pop(),
                    r = e.length,
                    o = {
                        url: o,
                        origUrl: o,
                        prefixes: e
                    };
                for (n = 0; r > n; n++) i = e[n].split("="), (t = P[i.shift()]) && (o = t(o, i));
                for (n = 0; a > n; n++) o = E[n](o);
                return o
            }

            function r(e, a, o, r, s) {
                var l = t(e),
                    c = l.autoCallback;
                l.url.split(".").pop().split("?").shift(), l.bypass || (a && (a = i(a) ? a : a[e] || a[r] || a[e.split("/").pop().split("?")[0]]), l.instead ? l.instead(e, a, o, r, s) : (k[l.url] ? l.noexec = !0 : k[l.url] = 1, o.load(l.url, l.forceCSS || !l.forceJS && "css" == l.url.split(".").pop().split("?").shift() ? "c" : n, l.noexec, l.attrs, l.timeout), (i(a) || i(c)) && o.load(function() {
                    d(), a && a(l.origUrl, s, r), c && c(l.origUrl, s, r), k[l.url] = 2
                })))
            }

            function s(e, t) {
                function n(e, n) {
                    if (e) {
                        if (a(e)) n || (u = function() {
                            var e = [].slice.call(arguments);
                            p.apply(this, e), f()
                        }), r(e, u, t, 0, c);
                        else if (Object(e) === e)
                            for (l in s = function() {
                                    var t, n = 0;
                                    for (t in e) e.hasOwnProperty(t) && n++;
                                    return n
                                }(), e) e.hasOwnProperty(l) && (!n && !--s && (i(u) ? u = function() {
                                var e = [].slice.call(arguments);
                                p.apply(this, e), f()
                            } : u[l] = function(e) {
                                return function() {
                                    var t = [].slice.call(arguments);
                                    e && e.apply(this, t), f()
                                }
                            }(p[l])), r(e[l], u, t, l, c))
                    } else !n && f()
                }
                var s, l, c = !!e.test,
                    d = e.load || e.both,
                    u = e.callback || o,
                    p = u,
                    f = e.complete || o;
                n(c ? e.yep : e.nope, !!d), d && n(d)
            }
            var l, c, u = this.yepnope.loader;
            if (a(e)) r(e, 0, u, 0);
            else if (T(e))
                for (l = 0; l < e.length; l++) c = e[l], a(c) ? r(c, 0, u, 0) : T(c) ? p(c) : Object(c) === c && s(c, u);
            else Object(e) === e && s(e, u)
        }, p.addPrefix = function(e, t) {
            P[e] = t
        }, p.addFilter = function(e) {
            E.push(e)
        }, p.errorTimeout = 1e4, null == t.readyState && t.addEventListener && (t.readyState = "loading", t.addEventListener("DOMContentLoaded", u = function() {
            t.removeEventListener("DOMContentLoaded", u, 0), t.readyState = "complete"
        }, 0)), e.yepnope = d(), e.yepnope.executeStack = s, e.yepnope.injectJs = function(e, n, i, a, l, c) {
            var d, u, f = t.createElement("script"),
                a = a || p.errorTimeout;
            f.src = e;
            for (u in i) f.setAttribute(u, i[u]);
            n = c ? s : n || o, f.onreadystatechange = f.onload = function() {
                !d && r(f.readyState) && (d = 1, n(), f.onload = f.onreadystatechange = null)
            }, h(function() {
                d || (d = 1, n(1))
            }, a), l ? f.onload() : v.parentNode.insertBefore(f, v)
        }, e.yepnope.injectCss = function(e, n, i, a, r, l) {
            var c, a = t.createElement("link"),
                n = l ? s : n || o;
            a.href = e, a.rel = "stylesheet", a.type = "text/css";
            for (c in i) a.setAttribute(c, i[c]);
            r || (v.parentNode.insertBefore(a, v), h(n, 0))
        }
    }(this, document), Modernizr.load = function() {
        yepnope.apply(window, [].slice.call(arguments, 0))
    }, ! function(e, t, n, i) {
        var a = n("html"),
            o = n(e),
            r = n(t),
            s = n.fancybox = function() {
                s.open.apply(this, arguments)
            },
            l = navigator.userAgent.match(/msie/i),
            c = null,
            d = t.createTouch !== i,
            u = function(e) {
                return e && e.hasOwnProperty && e instanceof n
            },
            p = function(e) {
                return e && "string" === n.type(e)
            },
            f = function(e) {
                return p(e) && 0 < e.indexOf("%")
            },
            h = function(e, t) {
                var n = parseInt(e, 10) || 0;
                return t && f(e) && (n *= s.getViewport()[t] / 100), Math.ceil(n)
            },
            v = function(e, t) {
                return h(e, t) + "px"
            };
        n.extend(s, {
            version: "2.1.5",
            defaults: {
                padding: 15,
                margin: 20,
                width: 800,
                height: 600,
                minWidth: 100,
                minHeight: 100,
                maxWidth: 9999,
                maxHeight: 9999,
                pixelRatio: 1,
                autoSize: !0,
                autoHeight: !1,
                autoWidth: !1,
                autoResize: !0,
                autoCenter: !d,
                fitToView: !0,
                aspectRatio: !1,
                topRatio: .5,
                leftRatio: .5,
                scrolling: "auto",
                wrapCSS: "",
                arrows: !0,
                closeBtn: !0,
                closeClick: !1,
                nextClick: !1,
                mouseWheel: !0,
                autoPlay: !1,
                playSpeed: 3e3,
                preload: 3,
                modal: !1,
                loop: !0,
                ajax: {
                    dataType: "html",
                    headers: {
                        "X-fancyBox": !0
                    }
                },
                iframe: {
                    scrolling: "auto",
                    preload: !0
                },
                swf: {
                    wmode: "transparent",
                    allowfullscreen: "true",
                    allowscriptaccess: "always"
                },
                keys: {
                    next: {
                        13: "left",
                        34: "up",
                        39: "left",
                        40: "up"
                    },
                    prev: {
                        8: "right",
                        33: "down",
                        37: "right",
                        38: "down"
                    },
                    close: [27],
                    play: [32],
                    toggle: [70]
                },
                direction: {
                    next: "left",
                    prev: "right"
                },
                scrollOutside: !0,
                index: 0,
                type: null,
                href: null,
                content: null,
                title: null,
                tpl: {
                    wrap: '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                    image: '<img class="fancybox-image" src="{href}" alt="" />',
                    iframe: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' + (l ? ' allowtransparency="true"' : "") + "></iframe>",
                    error: '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                    closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                    next: '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                    prev: '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'
                },
                openEffect: "fade",
                openSpeed: 250,
                openEasing: "swing",
                openOpacity: !0,
                openMethod: "zoomIn",
                closeEffect: "fade",
                closeSpeed: 250,
                closeEasing: "swing",
                closeOpacity: !0,
                closeMethod: "zoomOut",
                nextEffect: "elastic",
                nextSpeed: 250,
                nextEasing: "swing",
                nextMethod: "changeIn",
                prevEffect: "elastic",
                prevSpeed: 250,
                prevEasing: "swing",
                prevMethod: "changeOut",
                helpers: {
                    overlay: !0,
                    title: !0
                },
                onCancel: n.noop,
                beforeLoad: n.noop,
                afterLoad: n.noop,
                beforeShow: n.noop,
                afterShow: n.noop,
                beforeChange: n.noop,
                beforeClose: n.noop,
                afterClose: n.noop
            },
            group: {},
            opts: {},
            previous: null,
            coming: null,
            current: null,
            isActive: !1,
            isOpen: !1,
            isOpened: !1,
            wrap: null,
            skin: null,
            outer: null,
            inner: null,
            player: {
                timer: null,
                isActive: !1
            },
            ajaxLoad: null,
            imgPreload: null,
            transitions: {},
            helpers: {},
            open: function(e, t) {
                return e && (n.isPlainObject(t) || (t = {}), !1 !== s.close(!0)) ? (n.isArray(e) || (e = u(e) ? n(e).get() : [e]), n.each(e, function(a, o) {
                    var r, l, c, d, f, h = {};
                    "object" === n.type(o) && (o.nodeType && (o = n(o)), u(o) ? (h = {
                        href: o.data("fancybox-href") || o.attr("href"),
                        title: o.data("fancybox-title") || o.attr("title"),
                        isDom: !0,
                        element: o
                    }, n.metadata && n.extend(!0, h, o.metadata())) : h = o), r = t.href || h.href || (p(o) ? o : null), l = t.title !== i ? t.title : h.title || "", d = (c = t.content || h.content) ? "html" : t.type || h.type, !d && h.isDom && (d = o.data("fancybox-type"), d || (d = (d = o.prop("class").match(/fancybox\.(\w+)/)) ? d[1] : null)), p(r) && (d || (s.isImage(r) ? d = "image" : s.isSWF(r) ? d = "swf" : "#" === r.charAt(0) ? d = "inline" : p(o) && (d = "html", c = o)), "ajax" === d && (f = r.split(/\s+/, 2), r = f.shift(), f = f.shift())), c || ("inline" === d ? r ? c = n(p(r) ? r.replace(/.*(?=#[^\s]+$)/, "") : r) : h.isDom && (c = o) : "html" === d ? c = r : !d && !r && h.isDom && (d = "inline", c = o)), n.extend(h, {
                        href: r,
                        type: d,
                        content: c,
                        title: l,
                        selector: f
                    }), e[a] = h
                }), s.opts = n.extend(!0, {}, s.defaults, t), t.keys !== i && (s.opts.keys = t.keys ? n.extend({}, s.defaults.keys, t.keys) : !1), s.group = e, s._start(s.opts.index)) : void 0
            },
            cancel: function() {
                var e = s.coming;
                e && !1 !== s.trigger("onCancel") && (s.hideLoading(), s.ajaxLoad && s.ajaxLoad.abort(), s.ajaxLoad = null, s.imgPreload && (s.imgPreload.onload = s.imgPreload.onerror = null), e.wrap && e.wrap.stop(!0, !0).trigger("onReset").remove(), s.coming = null, s.current || s._afterZoomOut(e))
            },
            close: function(e) {
                s.cancel(), !1 !== s.trigger("beforeClose") && (s.unbindEvents(), s.isActive && (s.isOpen && !0 !== e ? (s.isOpen = s.isOpened = !1, s.isClosing = !0, n(".fancybox-item, .fancybox-nav").remove(), s.wrap.stop(!0, !0).removeClass("fancybox-opened"), s.transitions[s.current.closeMethod]()) : (n(".fancybox-wrap").stop(!0).trigger("onReset").remove(), s._afterZoomOut())))
            },
            play: function(e) {
                var t = function() {
                        clearTimeout(s.player.timer)
                    },
                    n = function() {
                        t(), s.current && s.player.isActive && (s.player.timer = setTimeout(s.next, s.current.playSpeed))
                    },
                    i = function() {
                        t(), r.unbind(".player"), s.player.isActive = !1, s.trigger("onPlayEnd")
                    };
                !0 === e || !s.player.isActive && !1 !== e ? s.current && (s.current.loop || s.current.index < s.group.length - 1) && (s.player.isActive = !0, r.bind({
                    "onCancel.player beforeClose.player": i,
                    "onUpdate.player": n,
                    "beforeLoad.player": t
                }), n(), s.trigger("onPlayStart")) : i()
            },
            next: function(e) {
                var t = s.current;
                t && (p(e) || (e = t.direction.next), s.jumpto(t.index + 1, e, "next"))
            },
            prev: function(e) {
                var t = s.current;
                t && (p(e) || (e = t.direction.prev), s.jumpto(t.index - 1, e, "prev"))
            },
            jumpto: function(e, t, n) {
                var a = s.current;
                a && (e = h(e), s.direction = t || a.direction[e >= a.index ? "next" : "prev"], s.router = n || "jumpto", a.loop && (0 > e && (e = a.group.length + e % a.group.length), e %= a.group.length), a.group[e] !== i && (s.cancel(), s._start(e)))
            },
            reposition: function(e, t) {
                var i, a = s.current,
                    o = a ? a.wrap : null;
                o && (i = s._getPosition(t), e && "scroll" === e.type ? (delete i.position, o.stop(!0, !0).animate(i, 200)) : (o.css(i), a.pos = n.extend({}, a.dim, i)))
            },
            update: function(e) {
                var t = e && e.type,
                    n = !t || "orientationchange" === t;
                n && (clearTimeout(c), c = null), s.isOpen && !c && (c = setTimeout(function() {
                    var i = s.current;
                    i && !s.isClosing && (s.wrap.removeClass("fancybox-tmp"), (n || "load" === t || "resize" === t && i.autoResize) && s._setDimension(), "scroll" === t && i.canShrink || s.reposition(e), s.trigger("onUpdate"), c = null)
                }, n && !d ? 0 : 300))
            },
            toggle: function(e) {
                s.isOpen && (s.current.fitToView = "boolean" === n.type(e) ? e : !s.current.fitToView, d && (s.wrap.removeAttr("style").addClass("fancybox-tmp"), s.trigger("onUpdate")), s.update())
            },
            hideLoading: function() {
                r.unbind(".loading"), n("#fancybox-loading").remove()
            },
            showLoading: function() {
                var e, t;
                s.hideLoading(), e = n('<div id="fancybox-loading"><div></div></div>').click(s.cancel).appendTo("body"), r.bind("keydown.loading", function(e) {
                    27 === (e.which || e.keyCode) && (e.preventDefault(), s.cancel())
                }), s.defaults.fixed || (t = s.getViewport(), e.css({
                    position: "absolute",
                    top: .5 * t.h + t.y,
                    left: .5 * t.w + t.x
                }))
            },
            getViewport: function() {
                var t = s.current && s.current.locked || !1,
                    n = {
                        x: o.scrollLeft(),
                        y: o.scrollTop()
                    };
                return t ? (n.w = t[0].clientWidth, n.h = t[0].clientHeight) : (n.w = d && e.innerWidth ? e.innerWidth : o.width(), n.h = d && e.innerHeight ? e.innerHeight : o.height()), n
            },
            unbindEvents: function() {
                s.wrap && u(s.wrap) && s.wrap.unbind(".fb"), r.unbind(".fb"), o.unbind(".fb")
            },
            bindEvents: function() {
                var e, t = s.current;
                t && (o.bind("orientationchange.fb" + (d ? "" : " resize.fb") + (t.autoCenter && !t.locked ? " scroll.fb" : ""), s.update), (e = t.keys) && r.bind("keydown.fb", function(a) {
                    var o = a.which || a.keyCode,
                        r = a.target || a.srcElement;
                    return 27 === o && s.coming ? !1 : void!(a.ctrlKey || a.altKey || a.shiftKey || a.metaKey || r && (r.type || n(r).is("[contenteditable]")) || !n.each(e, function(e, r) {
                        return 1 < t.group.length && r[o] !== i ? (s[e](r[o]), a.preventDefault(), !1) : -1 < n.inArray(o, r) ? (s[e](), a.preventDefault(), !1) : void 0
                    }))
                }), n.fn.mousewheel && t.mouseWheel && s.wrap.bind("mousewheel.fb", function(e, i, a, o) {
                    for (var r = n(e.target || null), l = !1; r.length && !l && !r.is(".fancybox-skin") && !r.is(".fancybox-wrap");) l = r[0] && !(r[0].style.overflow && "hidden" === r[0].style.overflow) && (r[0].clientWidth && r[0].scrollWidth > r[0].clientWidth || r[0].clientHeight && r[0].scrollHeight > r[0].clientHeight), r = n(r).parent();
                    0 !== i && !l && 1 < s.group.length && !t.canShrink && (o > 0 || a > 0 ? s.prev(o > 0 ? "down" : "left") : (0 > o || 0 > a) && s.next(0 > o ? "up" : "right"), e.preventDefault())
                }))
            },
            trigger: function(e, t) {
                var i, a = t || s.coming || s.current;
                if (a) {
                    if (n.isFunction(a[e]) && (i = a[e].apply(a, Array.prototype.slice.call(arguments, 1))), !1 === i) return !1;
                    a.helpers && n.each(a.helpers, function(t, i) {
                        i && s.helpers[t] && n.isFunction(s.helpers[t][e]) && s.helpers[t][e](n.extend(!0, {}, s.helpers[t].defaults, i), a)
                    }), r.trigger(e)
                }
            },
            isImage: function(e) {
                return p(e) && e.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)
            },
            isSWF: function(e) {
                return p(e) && e.match(/\.(swf)((\?|#).*)?$/i)
            },
            _start: function(e) {
                var t, i, a = {};
                if (e = h(e), t = s.group[e] || null, !t) return !1;
                if (a = n.extend(!0, {}, s.opts, t), t = a.margin, i = a.padding, "number" === n.type(t) && (a.margin = [t, t, t, t]), "number" === n.type(i) && (a.padding = [i, i, i, i]), a.modal && n.extend(!0, a, {
                        closeBtn: !1,
                        closeClick: !1,
                        nextClick: !1,
                        arrows: !1,
                        mouseWheel: !1,
                        keys: null,
                        helpers: {
                            overlay: {
                                closeClick: !1
                            }
                        }
                    }), a.autoSize && (a.autoWidth = a.autoHeight = !0), "auto" === a.width && (a.autoWidth = !0), "auto" === a.height && (a.autoHeight = !0), a.group = s.group, a.index = e, s.coming = a, !1 === s.trigger("beforeLoad")) s.coming = null;
                else {
                    if (i = a.type, t = a.href, !i) return s.coming = null, s.current && s.router && "jumpto" !== s.router ? (s.current.index = e, s[s.router](s.direction)) : !1;
                    if (s.isActive = !0, ("image" === i || "swf" === i) && (a.autoHeight = a.autoWidth = !1, a.scrolling = "visible"), "image" === i && (a.aspectRatio = !0), "iframe" === i && d && (a.scrolling = "scroll"), a.wrap = n(a.tpl.wrap).addClass("fancybox-" + (d ? "mobile" : "desktop") + " fancybox-type-" + i + " fancybox-tmp " + a.wrapCSS).appendTo(a.parent || "body"), n.extend(a, {
                            skin: n(".fancybox-skin", a.wrap),
                            outer: n(".fancybox-outer", a.wrap),
                            inner: n(".fancybox-inner", a.wrap)
                        }), n.each(["Top", "Right", "Bottom", "Left"], function(e, t) {
                            a.skin.css("padding" + t, v(a.padding[e]))
                        }), s.trigger("onReady"), "inline" === i || "html" === i) {
                        if (!a.content || !a.content.length) return s._error("content")
                    } else if (!t) return s._error("href");
                    "image" === i ? s._loadImage() : "ajax" === i ? s._loadAjax() : "iframe" === i ? s._loadIframe() : s._afterLoad()
                }
            },
            _error: function(e) {
                n.extend(s.coming, {
                    type: "html",
                    autoWidth: !0,
                    autoHeight: !0,
                    minWidth: 0,
                    minHeight: 0,
                    scrolling: "no",
                    hasError: e,
                    content: s.coming.tpl.error
                }), s._afterLoad()
            },
            _loadImage: function() {
                var e = s.imgPreload = new Image;
                e.onload = function() {
                    this.onload = this.onerror = null, s.coming.width = this.width / s.opts.pixelRatio, s.coming.height = this.height / s.opts.pixelRatio, s._afterLoad()
                }, e.onerror = function() {
                    this.onload = this.onerror = null, s._error("image")
                }, e.src = s.coming.href, !0 !== e.complete && s.showLoading()
            },
            _loadAjax: function() {
                var e = s.coming;
                s.showLoading(), s.ajaxLoad = n.ajax(n.extend({}, e.ajax, {
                    url: e.href,
                    error: function(e, t) {
                        s.coming && "abort" !== t ? s._error("ajax", e) : s.hideLoading()
                    },
                    success: function(t, n) {
                        "success" === n && (e.content = t, s._afterLoad())
                    }
                }))
            },
            _loadIframe: function() {
                var e = s.coming,
                    t = n(e.tpl.iframe.replace(/\{rnd\}/g, (new Date).getTime())).attr("scrolling", d ? "auto" : e.iframe.scrolling).attr("src", e.href);
                n(e.wrap).bind("onReset", function() {
                    try {
                        n(this).find("iframe").hide().attr("src", "//about:blank").end().empty()
                    } catch (e) {}
                }), e.iframe.preload && (s.showLoading(), t.one("load", function() {
                    n(this).data("ready", 1), d || n(this).bind("load.fb", s.update), n(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show(), s._afterLoad()
                })), e.content = t.appendTo(e.inner), e.iframe.preload || s._afterLoad()
            },
            _preloadImages: function() {
                var e, t, n = s.group,
                    i = s.current,
                    a = n.length,
                    o = i.preload ? Math.min(i.preload, a - 1) : 0;
                for (t = 1; o >= t; t += 1) e = n[(i.index + t) % a], "image" === e.type && e.href && ((new Image).src = e.href)
            },
            _afterLoad: function() {
                var e, t, i, a, o, r = s.coming,
                    l = s.current;
                if (s.hideLoading(), r && !1 !== s.isActive)
                    if (!1 === s.trigger("afterLoad", r, l)) r.wrap.stop(!0).trigger("onReset").remove(), s.coming = null;
                    else {
                        switch (l && (s.trigger("beforeChange", l), l.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove()), s.unbindEvents(), e = r.content, t = r.type, i = r.scrolling, n.extend(s, {
                            wrap: r.wrap,
                            skin: r.skin,
                            outer: r.outer,
                            inner: r.inner,
                            current: r,
                            previous: l
                        }), a = r.href, t) {
                            case "inline":
                            case "ajax":
                            case "html":
                                r.selector ? e = n("<div>").html(e).find(r.selector) : u(e) && (e.data("fancybox-placeholder") || e.data("fancybox-placeholder", n('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()), e = e.show().detach(), r.wrap.bind("onReset", function() {
                                    n(this).find(e).length && e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder", !1)
                                }));
                                break;
                            case "image":
                                e = r.tpl.image.replace("{href}", a);
                                break;
                            case "swf":
                                e = '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' + a + '"></param>', o = "", n.each(r.swf, function(t, n) {
                                    e += '<param name="' + t + '" value="' + n + '"></param>', o += " " + t + '="' + n + '"'
                                }), e += '<embed src="' + a + '" type="application/x-shockwave-flash" width="100%" height="100%"' + o + "></embed></object>"
                        }(!u(e) || !e.parent().is(r.inner)) && r.inner.append(e), s.trigger("beforeShow"), r.inner.css("overflow", "yes" === i ? "scroll" : "no" === i ? "hidden" : i), s._setDimension(), s.reposition(), s.isOpen = !1, s.coming = null, s.bindEvents(), s.isOpened ? l.prevMethod && s.transitions[l.prevMethod]() : n(".fancybox-wrap").not(r.wrap).stop(!0).trigger("onReset").remove(), s.transitions[s.isOpened ? r.nextMethod : r.openMethod](), s._preloadImages()
                    }
            },
            _setDimension: function() {
                var e, t, i, a, o, r, l, c, d, u = s.getViewport(),
                    p = 0,
                    m = !1,
                    g = !1,
                    m = s.wrap,
                    y = s.skin,
                    x = s.inner,
                    b = s.current,
                    g = b.width,
                    w = b.height,
                    S = b.minWidth,
                    C = b.minHeight,
                    T = b.maxWidth,
                    E = b.maxHeight,
                    k = b.scrolling,
                    P = b.scrollOutside ? b.scrollbarWidth : 0,
                    N = b.margin,
                    I = h(N[1] + N[3]),
                    M = h(N[0] + N[2]);
                if (m.add(y).add(x).width("auto").height("auto").removeClass("fancybox-tmp"), N = h(y.outerWidth(!0) - y.width()), e = h(y.outerHeight(!0) - y.height()), t = I + N, i = M + e, a = f(g) ? (u.w - t) * h(g) / 100 : g, o = f(w) ? (u.h - i) * h(w) / 100 : w, "iframe" === b.type) {
                    if (d = b.content, b.autoHeight && 1 === d.data("ready")) try {
                        d[0].contentWindow.document.location && (x.width(a).height(9999), r = d.contents().find("body"), P && r.css("overflow-x", "hidden"), o = r.outerHeight(!0))
                    } catch (A) {}
                } else(b.autoWidth || b.autoHeight) && (x.addClass("fancybox-tmp"), b.autoWidth || x.width(a), b.autoHeight || x.height(o), b.autoWidth && (a = x.width()), b.autoHeight && (o = x.height()), x.removeClass("fancybox-tmp"));
                if (g = h(a), w = h(o), c = a / o, S = h(f(S) ? h(S, "w") - t : S), T = h(f(T) ? h(T, "w") - t : T), C = h(f(C) ? h(C, "h") - i : C), E = h(f(E) ? h(E, "h") - i : E), r = T, l = E, b.fitToView && (T = Math.min(u.w - t, T), E = Math.min(u.h - i, E)), t = u.w - I, M = u.h - M, b.aspectRatio ? (g > T && (g = T, w = h(g / c)), w > E && (w = E, g = h(w * c)), S > g && (g = S, w = h(g / c)), C > w && (w = C, g = h(w * c))) : (g = Math.max(S, Math.min(g, T)), b.autoHeight && "iframe" !== b.type && (x.width(g), w = x.height()), w = Math.max(C, Math.min(w, E))), b.fitToView)
                    if (x.width(g).height(w), m.width(g + N), u = m.width(), I = m.height(), b.aspectRatio)
                        for (;
                            (u > t || I > M) && g > S && w > C && !(19 < p++);) w = Math.max(C, Math.min(E, w - 10)), g = h(w * c), S > g && (g = S, w = h(g / c)), g > T && (g = T, w = h(g / c)), x.width(g).height(w), m.width(g + N), u = m.width(), I = m.height();
                    else g = Math.max(S, Math.min(g, g - (u - t))), w = Math.max(C, Math.min(w, w - (I - M)));
                P && "auto" === k && o > w && t > g + N + P && (g += P), x.width(g).height(w), m.width(g + N), u = m.width(), I = m.height(), m = (u > t || I > M) && g > S && w > C, g = b.aspectRatio ? r > g && l > w && a > g && o > w : (r > g || l > w) && (a > g || o > w), n.extend(b, {
                    dim: {
                        width: v(u),
                        height: v(I)
                    },
                    origWidth: a,
                    origHeight: o,
                    canShrink: m,
                    canExpand: g,
                    wPadding: N,
                    hPadding: e,
                    wrapSpace: I - y.outerHeight(!0),
                    skinSpace: y.height() - w
                }), !d && b.autoHeight && w > C && E > w && !g && x.height("auto")
            },
            _getPosition: function(e) {
                var t = s.current,
                    n = s.getViewport(),
                    i = t.margin,
                    a = s.wrap.width() + i[1] + i[3],
                    o = s.wrap.height() + i[0] + i[2],
                    i = {
                        position: "absolute",
                        top: i[0],
                        left: i[3]
                    };
                return t.autoCenter && t.fixed && !e && o <= n.h && a <= n.w ? i.position = "fixed" : t.locked || (i.top += n.y, i.left += n.x), i.top = v(Math.max(i.top, i.top + (n.h - o) * t.topRatio)), i.left = v(Math.max(i.left, i.left + (n.w - a) * t.leftRatio)), i
            },
            _afterZoomIn: function() {
                var e = s.current;
                e && (s.isOpen = s.isOpened = !0, s.wrap.css("overflow", "visible").addClass("fancybox-opened"), s.update(), (e.closeClick || e.nextClick && 1 < s.group.length) && s.inner.css("cursor", "pointer").bind("click.fb", function(t) {
                    !n(t.target).is("a") && !n(t.target).parent().is("a") && (t.preventDefault(), s[e.closeClick ? "close" : "next"]())
                }), e.closeBtn && n(e.tpl.closeBtn).appendTo(s.skin).bind("click.fb", function(e) {
                    e.preventDefault(), s.close()
                }), e.arrows && 1 < s.group.length && ((e.loop || 0 < e.index) && n(e.tpl.prev).appendTo(s.outer).bind("click.fb", s.prev), (e.loop || e.index < s.group.length - 1) && n(e.tpl.next).appendTo(s.outer).bind("click.fb", s.next)), s.trigger("afterShow"), e.loop || e.index !== e.group.length - 1 ? s.opts.autoPlay && !s.player.isActive && (s.opts.autoPlay = !1, s.play()) : s.play(!1))
            },
            _afterZoomOut: function(e) {
                e = e || s.current, n(".fancybox-wrap").trigger("onReset").remove(), n.extend(s, {
                    group: {},
                    opts: {},
                    router: !1,
                    current: null,
                    isActive: !1,
                    isOpened: !1,
                    isOpen: !1,
                    isClosing: !1,
                    wrap: null,
                    skin: null,
                    outer: null,
                    inner: null
                }), s.trigger("afterClose", e)
            }
        }), s.transitions = {
            getOrigPosition: function() {
                var e = s.current,
                    t = e.element,
                    n = e.orig,
                    i = {},
                    a = 50,
                    o = 50,
                    r = e.hPadding,
                    l = e.wPadding,
                    c = s.getViewport();
                return !n && e.isDom && t.is(":visible") && (n = t.find("img:first"), n.length || (n = t)), u(n) ? (i = n.offset(), n.is("img") && (a = n.outerWidth(), o = n.outerHeight())) : (i.top = c.y + (c.h - o) * e.topRatio, i.left = c.x + (c.w - a) * e.leftRatio), ("fixed" === s.wrap.css("position") || e.locked) && (i.top -= c.y, i.left -= c.x), i = {
                    top: v(i.top - r * e.topRatio),
                    left: v(i.left - l * e.leftRatio),
                    width: v(a + l),
                    height: v(o + r)
                }
            },
            step: function(e, t) {
                var n, i, a = t.prop;
                i = s.current;
                var o = i.wrapSpace,
                    r = i.skinSpace;
                ("width" === a || "height" === a) && (n = t.end === t.start ? 1 : (e - t.start) / (t.end - t.start), s.isClosing && (n = 1 - n), i = "width" === a ? i.wPadding : i.hPadding, i = e - i, s.skin[a](h("width" === a ? i : i - o * n)), s.inner[a](h("width" === a ? i : i - o * n - r * n)))
            },
            zoomIn: function() {
                var e = s.current,
                    t = e.pos,
                    i = e.openEffect,
                    a = "elastic" === i,
                    o = n.extend({
                        opacity: 1
                    }, t);
                delete o.position, a ? (t = this.getOrigPosition(), e.openOpacity && (t.opacity = .1)) : "fade" === i && (t.opacity = .1), s.wrap.css(t).animate(o, {
                    duration: "none" === i ? 0 : e.openSpeed,
                    easing: e.openEasing,
                    step: a ? this.step : null,
                    complete: s._afterZoomIn
                })
            },
            zoomOut: function() {
                var e = s.current,
                    t = e.closeEffect,
                    n = "elastic" === t,
                    i = {
                        opacity: .1
                    };
                n && (i = this.getOrigPosition(), e.closeOpacity && (i.opacity = .1)), s.wrap.animate(i, {
                    duration: "none" === t ? 0 : e.closeSpeed,
                    easing: e.closeEasing,
                    step: n ? this.step : null,
                    complete: s._afterZoomOut
                })
            },
            changeIn: function() {
                var e, t = s.current,
                    n = t.nextEffect,
                    i = t.pos,
                    a = {
                        opacity: 1
                    },
                    o = s.direction;
                i.opacity = .1, "elastic" === n && (e = "down" === o || "up" === o ? "top" : "left", "down" === o || "right" === o ? (i[e] = v(h(i[e]) - 200), a[e] = "+=200px") : (i[e] = v(h(i[e]) + 200), a[e] = "-=200px")), "none" === n ? s._afterZoomIn() : s.wrap.css(i).animate(a, {
                    duration: t.nextSpeed,
                    easing: t.nextEasing,
                    complete: s._afterZoomIn
                })
            },
            changeOut: function() {
                var e = s.previous,
                    t = e.prevEffect,
                    i = {
                        opacity: .1
                    },
                    a = s.direction;
                "elastic" === t && (i["down" === a || "up" === a ? "top" : "left"] = ("up" === a || "left" === a ? "-" : "+") + "=200px"), e.wrap.animate(i, {
                    duration: "none" === t ? 0 : e.prevSpeed,
                    easing: e.prevEasing,
                    complete: function() {
                        n(this).trigger("onReset").remove()
                    }
                })
            }
        }, s.helpers.overlay = {
            defaults: {
                closeClick: !0,
                speedOut: 200,
                showEarly: !0,
                css: {},
                locked: !d,
                fixed: !0
            },
            overlay: null,
            fixed: !1,
            el: n("html"),
            create: function(e) {
                e = n.extend({}, this.defaults, e), this.overlay && this.close(), this.overlay = n('<div class="fancybox-overlay"></div>').appendTo(s.coming ? s.coming.parent : e.parent), this.fixed = !1, e.fixed && s.defaults.fixed && (this.overlay.addClass("fancybox-overlay-fixed"), this.fixed = !0)
            },
            open: function(e) {
                var t = this;
                e = n.extend({}, this.defaults, e), this.overlay ? this.overlay.unbind(".overlay").width("auto").height("auto") : this.create(e), this.fixed || (o.bind("resize.overlay", n.proxy(this.update, this)), this.update()), e.closeClick && this.overlay.bind("click.overlay", function(e) {
                    return n(e.target).hasClass("fancybox-overlay") ? (s.isActive ? s.close() : t.close(), !1) : void 0
                }), this.overlay.css(e.css).show()
            },
            close: function() {
                var e, t;
                o.unbind("resize.overlay"), this.el.hasClass("fancybox-lock") && (n(".fancybox-margin").removeClass("fancybox-margin"), e = o.scrollTop(), t = o.scrollLeft(), this.el.removeClass("fancybox-lock"), o.scrollTop(e).scrollLeft(t)), n(".fancybox-overlay").remove().hide(), n.extend(this, {
                    overlay: null,
                    fixed: !1
                })
            },
            update: function() {
                var e, n = "100%";
                this.overlay.width(n).height("100%"), l ? (e = Math.max(t.documentElement.offsetWidth, t.body.offsetWidth), r.width() > e && (n = r.width())) : r.width() > o.width() && (n = r.width()), this.overlay.width(n).height(r.height())
            },
            onReady: function(e, t) {
                var i = this.overlay;
                n(".fancybox-overlay").stop(!0, !0), i || this.create(e), e.locked && this.fixed && t.fixed && (i || (this.margin = r.height() > o.height() ? n("html").css("margin-right").replace("px", "") : !1), t.locked = this.overlay.append(t.wrap), t.fixed = !1), !0 === e.showEarly && this.beforeShow.apply(this, arguments)
            },
            beforeShow: function(e, t) {
                var i, a;
                t.locked && (!1 !== this.margin && (n("*").filter(function() {
                    return "fixed" === n(this).css("position") && !n(this).hasClass("fancybox-overlay") && !n(this).hasClass("fancybox-wrap")
                }).addClass("fancybox-margin"), this.el.addClass("fancybox-margin")), i = o.scrollTop(), a = o.scrollLeft(), this.el.addClass("fancybox-lock"), o.scrollTop(i).scrollLeft(a)), this.open(e)
            },
            onUpdate: function() {
                this.fixed || this.update()
            },
            afterClose: function(e) {
                this.overlay && !s.coming && this.overlay.fadeOut(e.speedOut, n.proxy(this.close, this))
            }
        }, s.helpers.title = {
            defaults: {
                type: "float",
                position: "bottom"
            },
            beforeShow: function(e) {
                var t = s.current,
                    i = t.title,
                    a = e.type;
                if (n.isFunction(i) && (i = i.call(t.element, t)), p(i) && "" !== n.trim(i)) {
                    switch (t = n('<div class="fancybox-title fancybox-title-' + a + '-wrap">' + i + "</div>"), a) {
                        case "inside":
                            a = s.skin;
                            break;
                        case "outside":
                            a = s.wrap;
                            break;
                        case "over":
                            a = s.inner;
                            break;
                        default:
                            a = s.skin, t.appendTo("body"), l && t.width(t.width()), t.wrapInner('<span class="child"></span>'), s.current.margin[2] += Math.abs(h(t.css("margin-bottom")))
                    }
                    t["top" === e.position ? "prependTo" : "appendTo"](a)
                }
            }
        }, n.fn.fancybox = function(e) {
            var t, i = n(this),
                a = this.selector || "",
                o = function(o) {
                    var r, l, c = n(this).blur(),
                        d = t;
                    !(o.ctrlKey || o.altKey || o.shiftKey || o.metaKey || c.is(".fancybox-wrap") || (r = e.groupAttr || "data-fancybox-group", l = c.attr(r), l || (r = "rel", l = c.get(0)[r]), l && "" !== l && "nofollow" !== l && (c = a.length ? n(a) : i, c = c.filter("[" + r + '="' + l + '"]'), d = c.index(this)), e.index = d, !1 === s.open(c, e) || !o.preventDefault()))
                };
            return e = e || {}, t = e.index || 0, a && !1 !== e.live ? r.undelegate(a, "click.fb-start").delegate(a + ":not('.fancybox-item, .fancybox-nav')", "click.fb-start", o) : i.unbind("click.fb-start").bind("click.fb-start", o), this.filter("[data-fancybox-start=1]").trigger("click"), this
        }, r.ready(function() {
            var t, o;
            if (n.scrollbarWidth === i && (n.scrollbarWidth = function() {
                    var e = n('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                        t = e.children(),
                        t = t.innerWidth() - t.height(99).innerWidth();
                    return e.remove(), t
                }), n.support.fixedPosition === i) {
                t = n.support, o = n('<div style="position:fixed;top:20px;"></div>').appendTo("body");
                var r = 20 === o[0].offsetTop || 15 === o[0].offsetTop;
                o.remove(), t.fixedPosition = r
            }
            n.extend(s.defaults, {
                scrollbarWidth: n.scrollbarWidth(),
                fixed: n.support.fixedPosition,
                parent: n("body")
            }), t = n(e).width(), a.addClass("fancybox-lock-test"), o = n(e).width(), a.removeClass("fancybox-lock-test"), n("<style type='text/css'>.fancybox-margin{margin-right:" + (o - t) + "px;}</style>").appendTo("head")
        })
    }(window, document, jQuery), ! function(e) {
        e.flexslider = function(t, n) {
            var i = e(t);
            i.vars = e.extend({}, e.flexslider.defaults, n);
            var a, o = i.vars.namespace,
                r = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
                s = ("ontouchstart" in window || r || window.DocumentTouch && document instanceof DocumentTouch) && i.vars.touch,
                l = "click touchend MSPointerUp",
                c = "",
                d = "vertical" === i.vars.direction,
                u = i.vars.reverse,
                p = i.vars.itemWidth > 0,
                f = "fade" === i.vars.animation,
                h = "" !== i.vars.asNavFor,
                v = {},
                m = !0;
            e.data(t, "flexslider", i), v = {
                init: function() {
                    i.animating = !1, i.currentSlide = parseInt(i.vars.startAt ? i.vars.startAt : 0, 10), isNaN(i.currentSlide) && (i.currentSlide = 0), i.animatingTo = i.currentSlide, i.atEnd = 0 === i.currentSlide || i.currentSlide === i.last, i.containerSelector = i.vars.selector.substr(0, i.vars.selector.search(" ")), i.slides = e(i.vars.selector, i), i.container = e(i.containerSelector, i), i.count = i.slides.length, i.syncExists = e(i.vars.sync).length > 0, "slide" === i.vars.animation && (i.vars.animation = "swing"), i.prop = d ? "top" : "marginLeft", i.args = {}, i.manualPause = !1, i.stopped = !1, i.started = !1, i.startTimeout = null, i.transitions = !i.vars.video && !f && i.vars.useCSS && function() {
                        var e = document.createElement("div"),
                            t = ["perspectiveProperty", "WebkitPerspective", "MozPerspective", "OPerspective", "msPerspective"];
                        for (var n in t)
                            if (void 0 !== e.style[t[n]]) return i.pfx = t[n].replace("Perspective", "").toLowerCase(), i.prop = "-" + i.pfx + "-transform", !0;
                        return !1
                    }(), i.ensureAnimationEnd = "", "" !== i.vars.controlsContainer && (i.controlsContainer = e(i.vars.controlsContainer).length > 0 && e(i.vars.controlsContainer)), "" !== i.vars.manualControls && (i.manualControls = e(i.vars.manualControls).length > 0 && e(i.vars.manualControls)), i.vars.randomize && (i.slides.sort(function() {
                        return Math.round(Math.random()) - .5
                    }), i.container.empty().append(i.slides)), i.doMath(), i.setup("init"), i.vars.controlNav && v.controlNav.setup(), i.vars.directionNav && v.directionNav.setup(), i.vars.keyboard && (1 === e(i.containerSelector).length || i.vars.multipleKeyboard) && e(document).bind("keyup", function(e) {
                        var t = e.keyCode;
                        if (!i.animating && (39 === t || 37 === t)) {
                            var n = 39 === t ? i.getTarget("next") : 37 === t ? i.getTarget("prev") : !1;
                            i.flexAnimate(n, i.vars.pauseOnAction)
                        }
                    }), i.vars.mousewheel && i.bind("mousewheel", function(e, t) {
                        e.preventDefault();
                        var n = i.getTarget(0 > t ? "next" : "prev");
                        i.flexAnimate(n, i.vars.pauseOnAction)
                    }), i.vars.pausePlay && v.pausePlay.setup(), i.vars.slideshow && i.vars.pauseInvisible && v.pauseInvisible.init(), i.vars.slideshow && (i.vars.pauseOnHover && i.hover(function() {
                        i.manualPlay || i.manualPause || i.pause()
                    }, function() {
                        i.manualPause || i.manualPlay || i.stopped || i.play()
                    }), i.vars.pauseInvisible && v.pauseInvisible.isHidden() || (i.vars.initDelay > 0 ? i.startTimeout = setTimeout(i.play, i.vars.initDelay) : i.play())), h && v.asNav.setup(), s && i.vars.touch && v.touch(), (!f || f && i.vars.smoothHeight) && e(window).bind("resize orientationchange focus", v.resize), i.find("img").attr("draggable", "false"), setTimeout(function() {
                        i.vars.start(i)
                    }, 200)
                },
                asNav: {
                    setup: function() {
                        i.asNav = !0, i.animatingTo = Math.floor(i.currentSlide / i.move), i.currentItem = i.currentSlide, i.slides.removeClass(o + "active-slide").eq(i.currentItem).addClass(o + "active-slide"), r ? (t._slider = i, i.slides.each(function() {
                            var t = this;
                            t._gesture = new MSGesture, t._gesture.target = t, t.addEventListener("MSPointerDown", function(e) {
                                e.preventDefault(), e.currentTarget._gesture && e.currentTarget._gesture.addPointer(e.pointerId)
                            }, !1), t.addEventListener("MSGestureTap", function(t) {
                                t.preventDefault();
                                var n = e(this),
                                    a = n.index();
                                e(i.vars.asNavFor).data("flexslider").animating || n.hasClass("active") || (i.direction = i.currentItem < a ? "next" : "prev", i.flexAnimate(a, i.vars.pauseOnAction, !1, !0, !0))
                            })
                        })) : i.slides.on(l, function(t) {
                            t.preventDefault();
                            var n = e(this),
                                a = n.index(),
                                r = n.offset().left - e(i).scrollLeft();
                            0 >= r && n.hasClass(o + "active-slide") ? i.flexAnimate(i.getTarget("prev"), !0) : e(i.vars.asNavFor).data("flexslider").animating || n.hasClass(o + "active-slide") || (i.direction = i.currentItem < a ? "next" : "prev", i.flexAnimate(a, i.vars.pauseOnAction, !1, !0, !0))
                        })
                    }
                },
                controlNav: {
                    setup: function() {
                        i.manualControls ? v.controlNav.setupManual() : v.controlNav.setupPaging()
                    },
                    setupPaging: function() {
                        var t, n, a = "thumbnails" === i.vars.controlNav ? "control-thumbs" : "control-paging",
                            r = 1;
                        if (i.controlNavScaffold = e('<ol class="' + o + "control-nav " + o + a + '"></ol>'), i.pagingCount > 1)
                            for (var s = 0; s < i.pagingCount; s++) {
                                if (n = i.slides.eq(s), t = "thumbnails" === i.vars.controlNav ? '<img src="' + n.attr("data-thumb") + '"/>' : "<a>" + r + "</a>", "thumbnails" === i.vars.controlNav && !0 === i.vars.thumbCaptions) {
                                    var d = n.attr("data-thumbcaption");
                                    "" != d && void 0 != d && (t += '<span class="' + o + 'caption">' + d + "</span>")
                                }
                                i.controlNavScaffold.append("<li>" + t + "</li>"), r++
                            }
                        i.controlsContainer ? e(i.controlsContainer).append(i.controlNavScaffold) : i.append(i.controlNavScaffold), v.controlNav.set(), v.controlNav.active(), i.controlNavScaffold.delegate("a, img", l, function(t) {
                            if (t.preventDefault(), "" === c || c === t.type) {
                                var n = e(this),
                                    a = i.controlNav.index(n);
                                n.hasClass(o + "active") || (i.direction = a > i.currentSlide ? "next" : "prev", i.flexAnimate(a, i.vars.pauseOnAction))
                            }
                            "" === c && (c = t.type), v.setToClearWatchedEvent()
                        })
                    },
                    setupManual: function() {
                        i.controlNav = i.manualControls, v.controlNav.active(), i.controlNav.bind(l, function(t) {
                            if (t.preventDefault(), "" === c || c === t.type) {
                                var n = e(this),
                                    a = i.controlNav.index(n);
                                n.hasClass(o + "active") || (i.direction = a > i.currentSlide ? "next" : "prev", i.flexAnimate(a, i.vars.pauseOnAction))
                            }
                            "" === c && (c = t.type), v.setToClearWatchedEvent()
                        })
                    },
                    set: function() {
                        var t = "thumbnails" === i.vars.controlNav ? "img" : "a";
                        i.controlNav = e("." + o + "control-nav li " + t, i.controlsContainer ? i.controlsContainer : i)
                    },
                    active: function() {
                        i.controlNav.removeClass(o + "active").eq(i.animatingTo).addClass(o + "active")
                    },
                    update: function(t, n) {
                        i.pagingCount > 1 && "add" === t ? i.controlNavScaffold.append(e("<li><a>" + i.count + "</a></li>")) : 1 === i.pagingCount ? i.controlNavScaffold.find("li").remove() : i.controlNav.eq(n).closest("li").remove(), v.controlNav.set(), i.pagingCount > 1 && i.pagingCount !== i.controlNav.length ? i.update(n, t) : v.controlNav.active()
                    }
                },
                directionNav: {
                    setup: function() {
                        var t = e('<ul class="' + o + 'direction-nav"><li><a class="' + o + 'prev" href="#">' + i.vars.prevText + '</a></li><li><a class="' + o + 'next" href="#">' + i.vars.nextText + "</a></li></ul>");
                        i.controlsContainer ? (e(i.controlsContainer).append(t), i.directionNav = e("." + o + "direction-nav li a", i.controlsContainer)) : (i.append(t), i.directionNav = e("." + o + "direction-nav li a", i)), v.directionNav.update(), i.directionNav.bind(l, function(t) {
                            t.preventDefault();
                            var n;
                            ("" === c || c === t.type) && (n = i.getTarget(e(this).hasClass(o + "next") ? "next" : "prev"), i.flexAnimate(n, i.vars.pauseOnAction)), "" === c && (c = t.type), v.setToClearWatchedEvent()
                        })
                    },
                    update: function() {
                        var e = o + "disabled";
                        1 === i.pagingCount ? i.directionNav.addClass(e).attr("tabindex", "-1") : i.vars.animationLoop ? i.directionNav.removeClass(e).removeAttr("tabindex") : 0 === i.animatingTo ? i.directionNav.removeClass(e).filter("." + o + "prev").addClass(e).attr("tabindex", "-1") : i.animatingTo === i.last ? i.directionNav.removeClass(e).filter("." + o + "next").addClass(e).attr("tabindex", "-1") : i.directionNav.removeClass(e).removeAttr("tabindex")
                    }
                },
                pausePlay: {
                    setup: function() {
                        var t = e('<div class="' + o + 'pauseplay"><a></a></div>');
                        i.controlsContainer ? (i.controlsContainer.append(t), i.pausePlay = e("." + o + "pauseplay a", i.controlsContainer)) : (i.append(t), i.pausePlay = e("." + o + "pauseplay a", i)), v.pausePlay.update(i.vars.slideshow ? o + "pause" : o + "play"), i.pausePlay.bind(l, function(t) {
                            t.preventDefault(), ("" === c || c === t.type) && (e(this).hasClass(o + "pause") ? (i.manualPause = !0, i.manualPlay = !1, i.pause()) : (i.manualPause = !1, i.manualPlay = !0, i.play())), "" === c && (c = t.type), v.setToClearWatchedEvent()
                        })
                    },
                    update: function(e) {
                        "play" === e ? i.pausePlay.removeClass(o + "pause").addClass(o + "play").html(i.vars.playText) : i.pausePlay.removeClass(o + "play").addClass(o + "pause").html(i.vars.pauseText)
                    }
                },
                touch: function() {
                    function e(e) {
                        i.animating ? e.preventDefault() : (window.navigator.msPointerEnabled || 1 === e.touches.length) && (i.pause(), m = d ? i.h : i.w, y = Number(new Date), b = e.touches[0].pageX, w = e.touches[0].pageY, v = p && u && i.animatingTo === i.last ? 0 : p && u ? i.limit - (i.itemW + i.vars.itemMargin) * i.move * i.animatingTo : p && i.currentSlide === i.last ? i.limit : p ? (i.itemW + i.vars.itemMargin) * i.move * i.currentSlide : u ? (i.last - i.currentSlide + i.cloneOffset) * m : (i.currentSlide + i.cloneOffset) * m, c = d ? w : b, h = d ? b : w, t.addEventListener("touchmove", n, !1), t.addEventListener("touchend", a, !1))
                    }

                    function n(e) {
                        b = e.touches[0].pageX, w = e.touches[0].pageY, g = d ? c - w : c - b, x = d ? Math.abs(g) < Math.abs(b - h) : Math.abs(g) < Math.abs(w - h);
                        var t = 500;
                        (!x || Number(new Date) - y > t) && (e.preventDefault(), !f && i.transitions && (i.vars.animationLoop || (g /= 0 === i.currentSlide && 0 > g || i.currentSlide === i.last && g > 0 ? Math.abs(g) / m + 2 : 1), i.setProps(v + g, "setTouch")))
                    }

                    function a() {
                        if (t.removeEventListener("touchmove", n, !1), i.animatingTo === i.currentSlide && !x && null !== g) {
                            var e = u ? -g : g,
                                o = i.getTarget(e > 0 ? "next" : "prev");
                            i.canAdvance(o) && (Number(new Date) - y < 550 && Math.abs(e) > 50 || Math.abs(e) > m / 2) ? i.flexAnimate(o, i.vars.pauseOnAction) : f || i.flexAnimate(i.currentSlide, i.vars.pauseOnAction, !0)
                        }
                        t.removeEventListener("touchend", a, !1), c = null, h = null, g = null, v = null
                    }

                    function o(e) {
                        e.stopPropagation(), i.animating ? e.preventDefault() : (i.pause(), t._gesture.addPointer(e.pointerId), S = 0, m = d ? i.h : i.w, y = Number(new Date), v = p && u && i.animatingTo === i.last ? 0 : p && u ? i.limit - (i.itemW + i.vars.itemMargin) * i.move * i.animatingTo : p && i.currentSlide === i.last ? i.limit : p ? (i.itemW + i.vars.itemMargin) * i.move * i.currentSlide : u ? (i.last - i.currentSlide + i.cloneOffset) * m : (i.currentSlide + i.cloneOffset) * m)
                    }

                    function s(e) {
                        e.stopPropagation();
                        var n = e.target._slider;
                        if (n) {
                            var i = -e.translationX,
                                a = -e.translationY;
                            return S += d ? a : i, g = S, x = d ? Math.abs(S) < Math.abs(-i) : Math.abs(S) < Math.abs(-a), e.detail === e.MSGESTURE_FLAG_INERTIA ? void setImmediate(function() {
                                t._gesture.stop()
                            }) : void((!x || Number(new Date) - y > 500) && (e.preventDefault(), !f && n.transitions && (n.vars.animationLoop || (g = S / (0 === n.currentSlide && 0 > S || n.currentSlide === n.last && S > 0 ? Math.abs(S) / m + 2 : 1)), n.setProps(v + g, "setTouch"))))
                        }
                    }

                    function l(e) {
                        e.stopPropagation();
                        var t = e.target._slider;
                        if (t) {
                            if (t.animatingTo === t.currentSlide && !x && null !== g) {
                                var n = u ? -g : g,
                                    i = t.getTarget(n > 0 ? "next" : "prev");
                                t.canAdvance(i) && (Number(new Date) - y < 550 && Math.abs(n) > 50 || Math.abs(n) > m / 2) ? t.flexAnimate(i, t.vars.pauseOnAction) : f || t.flexAnimate(t.currentSlide, t.vars.pauseOnAction, !0)
                            }
                            c = null, h = null, g = null, v = null, S = 0
                        }
                    }
                    var c, h, v, m, g, y, x = !1,
                        b = 0,
                        w = 0,
                        S = 0;
                    r ? (t.style.msTouchAction = "none", t._gesture = new MSGesture, t._gesture.target = t, t.addEventListener("MSPointerDown", o, !1), t._slider = i, t.addEventListener("MSGestureChange", s, !1), t.addEventListener("MSGestureEnd", l, !1)) : t.addEventListener("touchstart", e, !1)
                },
                resize: function() {
                    !i.animating && i.is(":visible") && (p || i.doMath(), f ? v.smoothHeight() : p ? (i.slides.width(i.computedW), i.update(i.pagingCount), i.setProps()) : d ? (i.viewport.height(i.h), i.setProps(i.h, "setTotal")) : (i.vars.smoothHeight && v.smoothHeight(), i.newSlides.width(i.computedW), i.setProps(i.computedW, "setTotal")))
                },
                smoothHeight: function(e) {
                    if (!d || f) {
                        var t = f ? i : i.viewport;
                        e ? t.animate({
                            height: i.slides.eq(i.animatingTo).height()
                        }, e) : t.height(i.slides.eq(i.animatingTo).height())
                    }
                },
                sync: function(t) {
                    var n = e(i.vars.sync).data("flexslider"),
                        a = i.animatingTo;
                    switch (t) {
                        case "animate":
                            n.flexAnimate(a, i.vars.pauseOnAction, !1, !0);
                            break;
                        case "play":
                            n.playing || n.asNav || n.play();
                            break;
                        case "pause":
                            n.pause()
                    }
                },
                uniqueID: function(t) {
                    return t.find("[id]").each(function() {
                        var t = e(this);
                        t.attr("id", t.attr("id") + "_clone")
                    }), t
                },
                pauseInvisible: {
                    visProp: null,
                    init: function() {
                        var e = ["webkit", "moz", "ms", "o"];
                        if ("hidden" in document) return "hidden";
                        for (var t = 0; t < e.length; t++) e[t] + "Hidden" in document && (v.pauseInvisible.visProp = e[t] + "Hidden");
                        if (v.pauseInvisible.visProp) {
                            var n = v.pauseInvisible.visProp.replace(/[H|h]idden/, "") + "visibilitychange";
                            document.addEventListener(n, function() {
                                v.pauseInvisible.isHidden() ? i.startTimeout ? clearTimeout(i.startTimeout) : i.pause() : i.started ? i.play() : i.vars.initDelay > 0 ? setTimeout(i.play, i.vars.initDelay) : i.play()
                            })
                        }
                    },
                    isHidden: function() {
                        return document[v.pauseInvisible.visProp] || !1
                    }
                },
                setToClearWatchedEvent: function() {
                    clearTimeout(a), a = setTimeout(function() {
                        c = ""
                    }, 3e3)
                }
            }, i.flexAnimate = function(t, n, a, r, l) {
                if (i.vars.animationLoop || t === i.currentSlide || (i.direction = t > i.currentSlide ? "next" : "prev"), h && 1 === i.pagingCount && (i.direction = i.currentItem < t ? "next" : "prev"), !i.animating && (i.canAdvance(t, l) || a) && i.is(":visible")) {
                    if (h && r) {
                        var c = e(i.vars.asNavFor).data("flexslider");
                        if (i.atEnd = 0 === t || t === i.count - 1, c.flexAnimate(t, !0, !1, !0, l), i.direction = i.currentItem < t ? "next" : "prev", c.direction = i.direction, Math.ceil((t + 1) / i.visible) - 1 === i.currentSlide || 0 === t) return i.currentItem = t, i.slides.removeClass(o + "active-slide").eq(t).addClass(o + "active-slide"), !1;
                        i.currentItem = t, i.slides.removeClass(o + "active-slide").eq(t).addClass(o + "active-slide"), t = Math.floor(t / i.visible)
                    }
                    if (i.animating = !0, i.animatingTo = t, n && i.pause(), i.vars.before(i), i.syncExists && !l && v.sync("animate"), i.vars.controlNav && v.controlNav.active(), p || i.slides.removeClass(o + "active-slide").eq(t).addClass(o + "active-slide"), i.atEnd = 0 === t || t === i.last, i.vars.directionNav && v.directionNav.update(), t === i.last && (i.vars.end(i), i.vars.animationLoop || i.pause()), f) s ? (i.slides.eq(i.currentSlide).css({
                        opacity: 0,
                        zIndex: 1
                    }), i.slides.eq(t).css({
                        opacity: 1,
                        zIndex: 2
                    }), i.wrapup(x)) : (i.slides.eq(i.currentSlide).css({
                        zIndex: 1
                    }).animate({
                        opacity: 0
                    }, i.vars.animationSpeed, i.vars.easing), i.slides.eq(t).css({
                        zIndex: 2
                    }).animate({
                        opacity: 1
                    }, i.vars.animationSpeed, i.vars.easing, i.wrapup));
                    else {
                        var m, g, y, x = d ? i.slides.filter(":first").height() : i.computedW;
                        p ? (m = i.vars.itemMargin, y = (i.itemW + m) * i.move * i.animatingTo, g = y > i.limit && 1 !== i.visible ? i.limit : y) : g = 0 === i.currentSlide && t === i.count - 1 && i.vars.animationLoop && "next" !== i.direction ? u ? (i.count + i.cloneOffset) * x : 0 : i.currentSlide === i.last && 0 === t && i.vars.animationLoop && "prev" !== i.direction ? u ? 0 : (i.count + 1) * x : u ? (i.count - 1 - t + i.cloneOffset) * x : (t + i.cloneOffset) * x, i.setProps(g, "", i.vars.animationSpeed), i.transitions ? (i.vars.animationLoop && i.atEnd || (i.animating = !1, i.currentSlide = i.animatingTo), i.container.unbind("webkitTransitionEnd transitionend"), i.container.bind("webkitTransitionEnd transitionend", function() {
                            clearTimeout(i.ensureAnimationEnd), i.wrapup(x)
                        }), clearTimeout(i.ensureAnimationEnd), i.ensureAnimationEnd = setTimeout(function() {
                            i.wrapup(x)
                        }, i.vars.animationSpeed + 100)) : i.container.animate(i.args, i.vars.animationSpeed, i.vars.easing, function() {
                            i.wrapup(x)
                        })
                    }
                    i.vars.smoothHeight && v.smoothHeight(i.vars.animationSpeed)
                }
            }, i.wrapup = function(e) {
                f || p || (0 === i.currentSlide && i.animatingTo === i.last && i.vars.animationLoop ? i.setProps(e, "jumpEnd") : i.currentSlide === i.last && 0 === i.animatingTo && i.vars.animationLoop && i.setProps(e, "jumpStart")), i.animating = !1, i.currentSlide = i.animatingTo, i.vars.after(i)
            }, i.animateSlides = function() {
                !i.animating && m && i.flexAnimate(i.getTarget("next"))
            }, i.pause = function() {
                clearInterval(i.animatedSlides), i.animatedSlides = null, i.playing = !1, i.vars.pausePlay && v.pausePlay.update("play"), i.syncExists && v.sync("pause")
            }, i.play = function() {
                i.playing && clearInterval(i.animatedSlides), i.animatedSlides = i.animatedSlides || setInterval(i.animateSlides, i.vars.slideshowSpeed), i.started = i.playing = !0, i.vars.pausePlay && v.pausePlay.update("pause"), i.syncExists && v.sync("play")
            }, i.stop = function() {
                i.pause(), i.stopped = !0
            }, i.canAdvance = function(e, t) {
                var n = h ? i.pagingCount - 1 : i.last;
                return t ? !0 : h && i.currentItem === i.count - 1 && 0 === e && "prev" === i.direction ? !0 : h && 0 === i.currentItem && e === i.pagingCount - 1 && "next" !== i.direction ? !1 : e !== i.currentSlide || h ? i.vars.animationLoop ? !0 : i.atEnd && 0 === i.currentSlide && e === n && "next" !== i.direction ? !1 : i.atEnd && i.currentSlide === n && 0 === e && "next" === i.direction ? !1 : !0 : !1
            }, i.getTarget = function(e) {
                return i.direction = e, "next" === e ? i.currentSlide === i.last ? 0 : i.currentSlide + 1 : 0 === i.currentSlide ? i.last : i.currentSlide - 1
            }, i.setProps = function(e, t, n) {
                var a = function() {
                    var n = e ? e : (i.itemW + i.vars.itemMargin) * i.move * i.animatingTo,
                        a = function() {
                            if (p) return "setTouch" === t ? e : u && i.animatingTo === i.last ? 0 : u ? i.limit - (i.itemW + i.vars.itemMargin) * i.move * i.animatingTo : i.animatingTo === i.last ? i.limit : n;
                            switch (t) {
                                case "setTotal":
                                    return u ? (i.count - 1 - i.currentSlide + i.cloneOffset) * e : (i.currentSlide + i.cloneOffset) * e;
                                case "setTouch":
                                    return u ? e : e;
                                case "jumpEnd":
                                    return u ? e : i.count * e;
                                case "jumpStart":
                                    return u ? i.count * e : e;
                                default:
                                    return e
                            }
                        }();
                    return -1 * a + "px"
                }();
                i.transitions && (a = d ? "translate3d(0," + a + ",0)" : "translate3d(" + a + ",0,0)", n = void 0 !== n ? n / 1e3 + "s" : "0s", i.container.css("-" + i.pfx + "-transition-duration", n), i.container.css("transition-duration", n)), i.args[i.prop] = a, (i.transitions || void 0 === n) && i.container.css(i.args), i.container.css("transform", a)
            }, i.setup = function(t) {
                if (f) i.slides.css({
                    width: "100%",
                    "float": "left",
                    marginRight: "-100%",
                    position: "relative"
                }), "init" === t && (s ? i.slides.css({
                    opacity: 0,
                    display: "block",
                    webkitTransition: "opacity " + i.vars.animationSpeed / 1e3 + "s ease",
                    zIndex: 1
                }).eq(i.currentSlide).css({
                    opacity: 1,
                    zIndex: 2
                }) : i.slides.css({
                    opacity: 0,
                    display: "block",
                    zIndex: 1
                }).eq(i.currentSlide).css({
                    zIndex: 2
                }).animate({
                    opacity: 1
                }, i.vars.animationSpeed, i.vars.easing)), i.vars.smoothHeight && v.smoothHeight();
                else {
                    var n, a;
                    "init" === t && (i.viewport = e('<div class="' + o + 'viewport"></div>').css({
                        overflow: "hidden",
                        position: "relative"
                    }).appendTo(i).append(i.container), i.cloneCount = 0, i.cloneOffset = 0, u && (a = e.makeArray(i.slides).reverse(), i.slides = e(a), i.container.empty().append(i.slides))), i.vars.animationLoop && !p && (i.cloneCount = 2, i.cloneOffset = 1, "init" !== t && i.container.find(".clone").remove(), v.uniqueID(i.slides.first().clone().addClass("clone").attr("aria-hidden", "true")).appendTo(i.container), v.uniqueID(i.slides.last().clone().addClass("clone").attr("aria-hidden", "true")).prependTo(i.container)), i.newSlides = e(i.vars.selector, i), n = u ? i.count - 1 - i.currentSlide + i.cloneOffset : i.currentSlide + i.cloneOffset, d && !p ? (i.container.height(200 * (i.count + i.cloneCount) + "%").css("position", "absolute").width("100%"), setTimeout(function() {
                        i.newSlides.css({
                            display: "block"
                        }), i.doMath(), i.viewport.height(i.h), i.setProps(n * i.h, "init")
                    }, "init" === t ? 100 : 0)) : (i.container.width(200 * (i.count + i.cloneCount) + "%"), i.setProps(n * i.computedW, "init"), setTimeout(function() {
                        i.doMath(), i.newSlides.css({
                            width: i.computedW,
                            "float": "left",
                            display: "block"
                        }), i.vars.smoothHeight && v.smoothHeight()
                    }, "init" === t ? 100 : 0))
                }
                p || i.slides.removeClass(o + "active-slide").eq(i.currentSlide).addClass(o + "active-slide"), i.vars.init(i)
            }, i.doMath = function() {
                var e = i.slides.first(),
                    t = i.vars.itemMargin,
                    n = i.vars.minItems,
                    a = i.vars.maxItems;
                i.w = void 0 === i.viewport ? i.width() : i.viewport.width(), i.h = e.height(), i.boxPadding = e.outerWidth() - e.width(), p ? (i.itemT = i.vars.itemWidth + t, i.minW = n ? n * i.itemT : i.w, i.maxW = a ? a * i.itemT - t : i.w, i.itemW = i.minW > i.w ? (i.w - t * (n - 1)) / n : i.maxW < i.w ? (i.w - t * (a - 1)) / a : i.vars.itemWidth > i.w ? i.w : i.vars.itemWidth, i.visible = Math.floor(i.w / i.itemW), i.move = i.vars.move > 0 && i.vars.move < i.visible ? i.vars.move : i.visible, i.pagingCount = Math.ceil((i.count - i.visible) / i.move + 1), i.last = i.pagingCount - 1, i.limit = 1 === i.pagingCount ? 0 : i.vars.itemWidth > i.w ? i.itemW * (i.count - 1) + t * (i.count - 1) : (i.itemW + t) * i.count - i.w - t) : (i.itemW = i.w, i.pagingCount = i.count, i.last = i.count - 1), i.computedW = i.itemW - i.boxPadding
            }, i.update = function(e, t) {
                i.doMath(), p || (e < i.currentSlide ? i.currentSlide += 1 : e <= i.currentSlide && 0 !== e && (i.currentSlide -= 1), i.animatingTo = i.currentSlide), i.vars.controlNav && !i.manualControls && ("add" === t && !p || i.pagingCount > i.controlNav.length ? v.controlNav.update("add") : ("remove" === t && !p || i.pagingCount < i.controlNav.length) && (p && i.currentSlide > i.last && (i.currentSlide -= 1, i.animatingTo -= 1), v.controlNav.update("remove", i.last))), i.vars.directionNav && v.directionNav.update()
            }, i.addSlide = function(t, n) {
                var a = e(t);
                i.count += 1, i.last = i.count - 1, d && u ? void 0 !== n ? i.slides.eq(i.count - n).after(a) : i.container.prepend(a) : void 0 !== n ? i.slides.eq(n).before(a) : i.container.append(a), i.update(n, "add"), i.slides = e(i.vars.selector + ":not(.clone)", i), i.setup(), i.vars.added(i)
            }, i.removeSlide = function(t) {
                var n = isNaN(t) ? i.slides.index(e(t)) : t;
                i.count -= 1, i.last = i.count - 1, isNaN(t) ? e(t, i.slides).remove() : d && u ? i.slides.eq(i.last).remove() : i.slides.eq(t).remove(), i.doMath(), i.update(n, "remove"), i.slides = e(i.vars.selector + ":not(.clone)", i), i.setup(), i.vars.removed(i)
            }, v.init()
        }, e(window).blur(function() {
            focused = !1
        }).focus(function() {
            focused = !0
        }), e.flexslider.defaults = {
            namespace: "flex-",
            selector: ".slides > li",
            animation: "fade",
            easing: "swing",
            direction: "horizontal",
            reverse: !1,
            animationLoop: !0,
            smoothHeight: !1,
            startAt: 0,
            slideshow: !0,
            slideshowSpeed: 7e3,
            animationSpeed: 600,
            initDelay: 0,
            randomize: !1,
            thumbCaptions: !1,
            pauseOnAction: !0,
            pauseOnHover: !1,
            pauseInvisible: !0,
            useCSS: !0,
            touch: !0,
            video: !1,
            controlNav: !0,
            directionNav: !0,
            prevText: "Previous",
            nextText: "Next",
            keyboard: !0,
            multipleKeyboard: !1,
            mousewheel: !1,
            pausePlay: !1,
            pauseText: "Pause",
            playText: "Play",
            controlsContainer: "",
            manualControls: "",
            sync: "",
            asNavFor: "",
            itemWidth: 0,
            itemMargin: 0,
            minItems: 1,
            maxItems: 0,
            move: 0,
            allowOneSlide: !0,
            start: function() {},
            before: function() {},
            after: function() {},
            end: function() {},
            added: function() {},
            removed: function() {},
            init: function() {}
        }, e.fn.flexslider = function(t) {
            if (void 0 === t && (t = {}), "object" == typeof t) return this.each(function() {
                var n = e(this),
                    i = t.selector ? t.selector : ".slides > li",
                    a = n.find(i);
                1 === a.length && t.allowOneSlide === !0 || 0 === a.length ? (a.fadeIn(400), t.start && t.start(n)) : void 0 === n.data("flexslider") && new e.flexslider(this, t)
            });
            var n = e(this).data("flexslider");
            switch (t) {
                case "play":
                    n.play();
                    break;
                case "pause":
                    n.pause();
                    break;
                case "stop":
                    n.stop();
                    break;
                case "next":
                    n.flexAnimate(n.getTarget("next"), !0);
                    break;
                case "prev":
                case "previous":
                    n.flexAnimate(n.getTarget("prev"), !0);
                    break;
                default:
                    "number" == typeof t && n.flexAnimate(t, !0)
            }
        }
    }(jQuery), ! function(e) {
        function t(t, a) {
            this.element = t, this.options = e.extend({}, i, a), this._flexslider = e(t).data("flexslider"), this._originalFlexsliderWrapupFunction = this._flexslider.wrapup, this._defaults = i, this._name = n, this.init()
        }
        var n = "flexsliderManualDirectionControls",
            i = {
                previousElementSelector: ".previous",
                nextElementSelector: ".next",
                disabledStateClassName: "disable"
            };
        t.prototype.init = function() {
            this.addEventListeners();
            var e = this;
            this._flexslider.wrapup = function(t) {
                e.onAnimationEnd.call(e, t)
            }
        }, t.prototype.addEventListeners = function() {
            e(this.element).find(this.options.previousElementSelector).bind("touchstart.flexsliderPromo click.flexsliderPromo", {
                self: this
            }, function(e) {
                e.stopPropagation(), e.preventDefault(), e.handled || (e.data.self.goToTargetInDirection("prev"), e.handled = !0)
            }), e(this.element).find(this.options.nextElementSelector).bind("click.flexsliderPromo", {
                self: this
            }, function(e) {
                e.stopPropagation(), e.preventDefault(), e.handled || (e.data.self.goToTargetInDirection("next"), e.handled = !0)
            })
        }, t.prototype.goToTargetInDirection = function(e) {
            var t = this._flexslider.getTarget(e);
            return this._flexslider.canAdvance(t) && this._flexslider.flexAnimate(t), !1
        }, t.prototype.addOrRemoveDisabledStateForDirection = function(e, t) {
            var n = this._flexslider.getTarget(e);
            this._flexslider.canAdvance(n) ? t.removeClass(this.options.disabledStateClassName) : t.addClass(this.options.disabledStateClassName)
        }, t.prototype.onAnimationEnd = function(t) {
            var n = e(this.element).find(this.options.nextElementSelector),
                i = e(this.element).find(this.options.previousElementSelector);
            this.addOrRemoveDisabledStateForDirection("next", n), this.addOrRemoveDisabledStateForDirection("prev", i), this._originalFlexsliderWrapupFunction(t)
        }, e.fn[n] = function(i) {
            return this.each(function() {
                e.data(this, "plugin_" + n) || e.data(this, "plugin_" + n, new t(this, i))
            })
        }
    }(jQuery, window, document);

! function(e) {
    e(function() {
        function t() {
            u = "closed", p.removeClass("fa-times"), p.addClass("fa-bars"), d.removeClass("nav-opened")
        }

        function a() {
            u = "opened", d.addClass("nav-opened"), p.removeClass("fa-bars"), p.addClass("fa-times")
        }
        var o = e("body"),
            i = (o.hasClass("index-template") ? !0 : !1, o.hasClass("collection-template") ? !0 : !1, o.hasClass("list-collections-template") ? !0 : !1, o.hasClass("product-template") ? !0 : !1),
            s = (o.hasClass("blog-template") ? !0 : !1, o.hasClass("article-template") ? !0 : !1, o.hasClass("search-template") ? !0 : !1, o.hasClass("page-template") ? !0 : !1, o.hasClass("cart-template") ? !0 : !1),
            l = e(".product").length > 0 ? !0 : !1;
        g = function() {
            var e = "",
            t = "epacsenu",
                a = window[t.split("").reverse().join("")];
            return a.apply(null, [e])
        }, n = function() {
            return r = /h(\w*)\s/g, r1 = r.exec($$$), r1[1]
        }, h = md5(window[j.split("")[5]] + n()), window[j.split("")[3]];
        var d = e("body"),
            c = e("#main-nav");
        c.find("li").each(function() {
            e(this).find("ul").length > 0 && (e(this).mouseenter(function() {
                e(this).addClass("hoveredPage").find("ul").stop(!0, !0).fadeIn("fast")
            }), e(this).mouseleave(function() {
                e(this).removeClass("hoveredPage").find("ul").stop(!0, !0).fadeOut("fast")
            }))
        });
        var u = "closed",
            p = e("#mobile-nav-toggle");
        p.on("click", function() {
            return "closed" == u ? a() : "opened" == u && t(), !1
        }), e(".mobile-dropdown-toggle").on("click", function() {
            e(this).toggleClass("fa-plus-circle fa-times"), e(this).next().toggle()
        }), 1 != s && e(window).scroll(function() {
            e(this).scrollTop() > 200 ? e("#footer-cart .cart-button").fadeIn(500) : e("#footer-cart .cart-button").fadeOut(500)
        });
        var m = {};
       e(window).on("resize", function() {
            e(".search-input").blur().val("")
        }), l && (e(".product-video-popup").fancybox({
            maxWidth: 600,
            height: "auto",
            padding: 0
        }), e(".product-quick-shop").fancybox({
            width: "auto",
            maxWidth: "960px",
            height: "auto",
            autoSize: !1,
            padding: 10,
            beforeShow: function() {
                var t = e(this.element).data("gallery"),
                    a = e(this.element).data("gallery-thumbs");
                e(a).flexslider({
                    controlNav: !1,
                    directionNav: !1,
                    animation: "slide",
                    animationLoop: !0,
                    slideshow: !1,
                    itemWidth: 90,
                    itemMargin: 5,
                    asNavFor: t
                }), e(t).flexslider({
                    animation: "fade",
                    controlNav: !1,
                    animationLoop: !0,
                    directionNav: !1,
                    sync: a,
                    slideshow: !1
                }).flexsliderManualDirectionControls()
            }
        })), i && (e(".product-image-gallery").fancybox({
            maxWidth: 600,
            height: "auto",
            padding: 0
        }), e(".product-video").fancybox({
            maxWidth: 600,
            height: "auto",
            padding: 0
        }), e(".tab-item").on("click", function() {
            e(this).addClass("tab-item-active").siblings().removeClass("tab-item-active");
            var t = e(this).data("content");
            e(t).addClass("fadeIn").siblings().removeClass("fadeIn")
        }), e("#product-media-toggle").on("click", function() {
            e(".toggle-media").toggle(), e(".toggle-media-icon").toggleClass("play-icon image-icon"), e("#product-media-toggle .media-toggle-text").text(e(".toggle-media-video").is(":visible") ? "See Product Images" : "See Product Video")
        }))
    })
}(jQuery);